(function () {
  'use strict';

  /* ===========================================================================
   * Intelligems A/B test — /pages/acne | Redesign and reorder sections
   *
   * One test, many sections. Every section change is a MODULE at the bottom of
   * this file; the harness below never changes. Add a module, add its styles to
   * igacne-lp-redesign.css, done.
   *
   * Reordering is done in CSS, not by moving DOM nodes — see REORDER below.
   *
   * ── HOW THIS SHIPS ────────────────────────────────────────────────────────
   * This is a THEME ASSET, not a paste. `layout/theme.liquid` loads it (and its
   * stylesheet) only on this template, so it reaches every visitor to
   * /pages/acne — CONTROL INCLUDED — and does nothing until Intelligems adds the
   * flag. The whole of the test's Custom JS is:
   *
   *     document.documentElement.classList.add('igacne-v1')
   *
   * and its Custom CSS is empty.
   *
   * ⚠️ NEVER add that class from this file. Doing so puts every visitor in the
   * variant and there is no experiment left to measure. See "The gate" below.
   *
   * Why an asset rather than a paste: Intelligems stores Custom JS in a 65,535
   * byte field and TRUNCATES past it without warning — which it did, cutting
   * this file mid-token and silently dropping the whole test to control. As an
   * asset there is no limit, the CSS is parsed before first paint instead of
   * whenever the injector gets round to it, the comments survive into production
   * so stack traces stay readable, and the file finally has git history.
   * ======================================================================== */

  if (window.__igacne) return;
  window.__igacne = true;

  var CONFIG = {
    prefix: 'igacne',
    variantClass: 'igacne-v1',
    activeClass: 'igacne-on',

    mobileBreakpoint: 749,
    onlyOnPaths: ['/pages/acne'],
    failsafeMs: 8000,

    /* Every reviews click on this variant — Loox `#looxReviews` (no such node
       on this LP), the Trustpilot band, the hero stars row, the buy-box rating
       line — lands on the Severe Acne carousel, not an off-page profile.
       `beforeAfter.ctaTarget` already points here; this is the rest. */
    reviewsJump: {
      target: 'severeMulticolumn',
      label: 'View customer reviews'
    },

    /* Every section on the template, by its Shopify section id. The rendered
       wrapper is #shopify-section-<id> and is a direct child of #MainContent.
       Names are ours; the ids come from templates/page.acne-lp.json.
       Keep this list complete even for untouched sections — the reorder needs
       to know about all of them. */
    sections: {
      hero:              'hero_fullwidth_split_YTkLFd',       // AcneLP banner, "500,000 Acne Sufferers Cured (4.9/5)"
      quoteTeen:         'hero_fullwidth_split_gfTeen',       // "I Finally Stopped Hiding My Face"
      quoteSon:          'hero_fullwidth_split_sonQuote',     // "My Son Finally Feels Like Himself Again"
      beforeAfter:       'multicolumn_FCtQxB',                // "Before & Afters"
      returnPolicyTop:   'announcement_text_TU849T',          // "Our return policy is simple…"
      press:             'press_mention_np9yjh',              // press quotes
      howItWorks:        'norse_how_it_works_yfqH3B',
      doctorsMothers:    'norse_ambassador_section_LfJD6C',   // "Trusted By Leading Doctors & Mothers"
      severeMulticolumn: 'multicolumn_7kdbNN',                // "Severe Acne Fixed in Weeks" — the 7 before/after cards, ships `hidden`
      severeTestimonial: 'review_testimonial_4b8WMH',         // "Severe Acne Fixed in Weeks" — the flat testimonial image, visible in control
      buyBox:            'main_product_alt_HFVcpT',
      returnPolicyBelow: 'announcement_text_8fyATt',          // duplicate copy of returnPolicyTop
      builtToClear:      'norse_ingredients_section_fNy7m3',  // "Built to clear acne fast."
      clinicalTrial:     'long_section_blocks_igTUwg',        // "Published 3rd Party Clinical Trial…" (scientific claims)
      frontrow:          'frontrow_testimonials_FRtw01',
      ingredientsFirst:  'ingredients_first_4AyHRy',          // "Ingredients Come First"
      bigBrands:         'multicolumn_kn8Piy',                // "Why mainstream skincare can't copy us"
      arctic:            'arctic_ingredients_X7cizF',         // "Why Arctic Ingredients Are Incredibly Powerful"
      resultsFaster:     'long_section_blocks_xKFYLj',        // "Why Norse Customers Get Results Faster"
      lessThanOneWeek:   'review_testimonial_mCyMnK',         // "..using this less than 1 WEEK"
      simpleRoutine:     'simple_routine_gdtxzK',             // "So Easy Even Teens Love It"
      whyTrustUs:        'why_trust_us_CGH9ng',
      foundersNote:      'founders_note_xtDULX',
      newsletter:        'newsletter_signup_4wTkBx',
      stickyAtc:         'sticky_add_to_cart_9wzj4C'
    },

    /* Final render order, top to bottom. Every key must exist in `sections`.
       Anything omitted keeps its natural position AFTER the ordered ones, so an
       incomplete list degrades predictably instead of scrambling the page.
       LEAVE EMPTY until the full target order is confirmed against Figma —
       a half-applied reorder is worse than none. */
    order: [],

    /* Sections to hide outright in the variant.
       `returnPolicyTop` is the .ag-review-bar band ("Our return policy is
       simple, Acne will never return"). It sat between Before & After and the
       Doctors & Mothers band, where the designs have nothing — and the identical
       copy still renders further down as `returnPolicyBelow`, so hiding it also
       takes one duplicate off the page, which the brief asks for.

       `bigBrands` is `multicolumn_kn8Piy` ("Why mainstream skincare can't copy
       us"). The ingredients band replaces it — same three subjects, rewritten —
       so it is hidden rather than adapted. See CONFIG.ingredients.

       `severeTestimonial` is the OTHER "Severe Acne Fixed in Weeks" — a single
       flat screenshot of Julia's testimonial on black. The redesign replaces it
       with `severeMulticolumn`, whose seven before/after cards are what the
       frames draw, so leaving it would print the same headline twice.

       `resultsFaster` is `long_section_blocks_xKFYLj` ("Why Norse Customers Get
       Results Faster") — a heading block over a flat PNG of the comparison
       table. The redesign draws a real table, so the band replaces it outright.
       See CONFIG.resultsTable for why it is not adapted in place.

       ── 2026-08-14: Mario asked for EVERY remaining section to be hidden
       except the newsletter. The redesign is now a closed set — this list is
       "everything on the template that the frames do not draw", so the variant
       renders exactly the sections above plus the newsletter, and nothing else.

       Added in that pass:
         returnPolicyBelow  the surviving half of the duplicated return-policy
                            copy. ⚠️ This SUPERSEDES the 2026-08-10 call that
                            kept it — MEMORY's old open question 5 is now moot.
         ingredientsFirst   "Ingredients Come First"
         arctic             "Why Arctic Ingredients Are Incredibly Powerful"
         simpleRoutine      "So Easy Even Teens Love It" — also settles the
                            open decision about it duplicating the kit band.
         foundersNote       merged INTO whyTrustUs by the finalSection module,
                            so leaving it would print the founder twice.
         quoteTeen, quoteSon, howItWorks
                            these already render at zero height on the live
                            page, so hiding them changes nothing visible. They
                            are listed anyway: the intent is "only the frames
                            render", and a merchant re-enabling one in the admin
                            must not silently appear in the variant.

       ⚠️ NOT hidden, deliberately: `stickyAtc`
       (`sticky_add_to_cart_9wzj4C`). It is a fixed overlay bar, not a section
       in the page flow — no frame draws it because no frame could — and it is a
       direct path to the buy box, which is one of the two things this test
       measures. Hiding it would remove a conversion route the brief never asked
       to remove and would confound the result. **Flagged for Mario**: add
       'stickyAtc' to this array if he does want it gone. */
    hide: [
      'returnPolicyTop', 'severeTestimonial', 'bigBrands', 'resultsFaster',
      'returnPolicyBelow', 'ingredientsFirst', 'arctic', 'simpleRoutine',
      'foundersNote', 'quoteTeen', 'quoteSon', 'howItWorks'
    ],

    /* Targeted reorder. Every child of #MainContent first gets an order equal to
       its current DOM position, then these rules override the ones that move —
       so a partial reorder never scrambles the sections nobody has touched yet.
       `move` and `after` accept a CONFIG.sections key or one of our own injected
       bands (matched via [data-igacne-section]). */
    /* ⚠️ ORDER MATTERS HERE. Each rule reads its anchor's resolved order, so an
       anchor must appear before anything that hangs off it — `clinicalTrial
       after severeMulticolumn` only lands correctly because severeMulticolumn
       was placed on the line above. */
    moves: [
      { move: 'press', after: 'trustpilot' },
      { move: 'severeMulticolumn', after: 'buyBox' },
      { move: 'clinicalTrial', after: 'severeMulticolumn' },
      { move: 'frontrow', after: 'clinicalTrial' },
      { move: 'ingredients', after: 'frontrow' },
      { move: 'trustBadges', after: 'ingredients' },
      { move: 'builtToClear', after: 'trustBadges' },
      /* Mario, 2026-08-14: the comparison table goes after the TABBED
         ingredients section — that is `builtToClear`
         (norse_ingredients_section_fNy7m3, "Built to clear acne fast"), the one
         with the three tabs, not the `ingredients` band above it. */
      { move: 'resultsTable', after: 'builtToClear' },
      // …and the testimonial after the table (Mario, 2026-08-14)
      { move: 'lessThanOneWeek', after: 'resultsTable' }
    ],

    /* ── Hero (Figma 10198:3696 desktop / 10198:5753 mobile) ──
       The live section already carries the stars, heading, description, CTA and
       three benefit blocks, so this is a rewrite of copy + styling, not a
       rebuild. Only the pill is genuinely new. */
    hero: {
      /* ⚠️ Ticket 12 — THE HERO STARS, which is what the ticket meant. The theme
         draws a soft star: its path is all cubic curves, so the points come out
         rounded. The design uses the sharp-cornered star the rest of this build
         already uses — the same 14x14 path as the buy box review card and the
         Trustpilot row, so all three rows now share one shape.
         Only the `d` is swapped. `fill` stays `currentColor` so the section's own
         `--hfs-star` (#fc8933 today) still drives the colour; the snippet in the
         ticket hardcodes #E16203, so say the word if the hero should switch to
         the redesign orange too — that is a one-line CSS change, not this. */
      starPath: 'M6.85762 0L8.47648 4.98235H13.7152L9.477 8.06161L11.0959 13.044L6.85762 9.9647L2.61938 13.044L4.23824 8.06161L0 4.98235H5.23876L6.85762 0Z',

      // Empty = leave the current photo in place. Fill in once the
      // `div.hero-media` export (photo + badge bar, 2x, from Figma) is on the
      // Shopify CDN. The badges are intricate seals built from dozens of
      // vectors and per-letter rotated text in Figma — they have to ship as an
      // exported asset, they cannot be rebuilt in CSS.
      // One export serves both breakpoints — it already contains the card
      // background, the photo and the badge strip.
      image: {
        desktop: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/div.hero-media.webp?v=1786126975',
        mobile: '',
        alt: 'Norse Organics balms with clinical trust badges'
      },

      /* Canonical proof line. Hero stars, press heading and buy-box stars tail
         all read this so 800,000 / 500,000 / 693,485+ cannot coexist. */
      starsText: '693,485+ Acne Sufferers Cured (4.7/5)',

      // `strong` marks the run that renders in SemiBold.
      /* ⚠️ "for over 693,485+" double-hedges: the figure already carries the +.
         Dropping "over " is a copy change the ticket did not ask for, so it is
         left in — say the word and it is a one-word edit on the line below. */
      description: [
        { text: 'Our clinically proven wild Arctic botanicals are clearing acne for over ' },
        { text: '693,485+ people worldwide', strong: true },
        { text: '. No chemicals, no prescriptions, just pure plants that work starting from the very first use.' }
      ],

      ctaText: 'TRY IT RISK FREE & SAVE 40%',

      // Rewritten in DOM order. `lead` renders SemiBold, `rest` regular.
      benefits: [
        { lead: 'RESULTS', rest: ' within 24-48 hours of use' },
        { lead: 'ACNE-FREE', rest: ' in 60 Days or Money Back' },
        { lead: '2M+ jars', rest: ' sold world wide' }
      ],

      /* The theme ships a filled tick; the design uses a thin gold stroke.
         The path bounds are 14x10.5 — the layout box Figma measures — while the
         3px stroke bleeds outside it, hence the 17x13 viewBox. The CSS keeps the
         box at 14x10.5 and lets the SVG overflow, so the 8px gap to the label
         stays exactly as designed. */
      checkIcon:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M1.5 7L5.25866 11.1763C5.65521 11.6169 6.3458 11.6178 6.74349 11.1782L15.5 1.5" stroke="#F4B301" stroke-width="3" stroke-linecap="round"/>' +
        '</svg>',

      pillText: 'High Demand. Stock is Limited',
      pillIcon:
        '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<circle cx="9" cy="9" r="7.75" stroke="currentColor" stroke-width="1.5"/>' +
        '<path d="M9 4.75V9L11.75 10.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>'
    },

    /* ── Trustpilot (Figma 10198:3817 desktop / 10198:5872 mobile) ──
       New band, inserted directly after the hero. The IDs and tokens are
       verbatim from the brief.

       These render as Trustpilot-hosted <iframe>s: their font, layout and copy
       belong to Trustpilot and cannot be styled or rewritten from here. What we
       control is the band around them — background, border, padding, and which
       of the two widgets shows at each breakpoint. See MEMORY.md for the
       mismatch this creates against the Figma. */
    trustpilot: {
      /* 'static' renders the Figma composition ourselves; 'widget' embeds the
         official TrustBox. Flip this one value to switch back — the widget path
         below is kept intact and working. */
      mode: 'static',

      /* ---- static composition (Figma 10198:3817 / 10198:5872) ----
         NOTE ON THE NUMBERS: these are hardcoded. Trustpilot's live figures at
         build time were trustScore 4.7, 4.5 stars, 3,941 reviews. "500,000 Acne
         Sufferers Cured" is marketing copy, not a Trustpilot metric — showing it
         beside their logo is a brand-terms risk the team accepted.

         Assets live on the Shopify CDN. */
      staticContent: {
        scoreLabel: 'Excellent ',
        score: '4.7',
        /* ⚠️ Ticket 1. This used to read "800,000 Happy Customers", which is
           marketing copy and NOT a Trustpilot metric — MEMORY flagged showing it
           beside their logo as a brand-terms risk the team had accepted. The
           ticket replaces it with Trustpilot's own review count, which is what
           their terms expect next to the mark.
           ⚠️ HARDCODED, like the score: 4,004 is the count the ticket gives. It
           will drift. `mode: 'widget'` is the only version that self-updates. */
        countLead: '4,004',
        countRest: ' reviews on Trustpilot',
        /* The mobile frame is the Mini widget, which words it differently:
           "TrustScore 4.7 | 4,004 reviews". Same figures, widget phrasing. */
        mobileScoreLabel: 'TrustScore ',
        mobileSeparator: '  |  ',
        mobileCountRest: ' reviews',
        // the export is a wider crop than the 124.768x25.315 slot — the CSS
        // reproduces Figma's own 119.57% scale and clip rather than stretching it
        stars: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/trustpilot-stars.png?v=1786315321',
        logo: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/trustpilot-name.png?v=1786315320',
        // the mobile frame is a 2x screenshot of the Mini widget — see MEMORY.md
        mobile: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/trustpilot-full-mobile.png?v=1786315321',
        logoAlt: 'Trustpilot',
        starsAlt: '4.7 out of 5 stars'
      },

      /* ---- official widget (kept for mode: 'widget') ---- */
      bootstrap: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
      businessunitId: '66a5f452940a502fa4613218',
      locale: 'en-US',
      reviewUrl: 'https://www.trustpilot.com/review/norseorganics.co',
      desktop: {
        templateId: '5406e65db0d04a09e042d5fc',
        height: '30.73px',
        width: '100%',
        token: '483fcb34-6d34-4b1c-b9cd-1165c4f7820d'
      },
      mobile: {
        templateId: '53aa8807dec7e10d38f59f32',
        height: '163px',
        width: '100%',
        token: 'ee6b046c-c700-4259-89ad-d60c7b5c997f'
      }
    },

    /* ── Before & After (Figma 10198:3860 desktop / 10198:5926 mobile) ──
       Section multicolumn_FCtQxB. The carousel and the arrows already match the
       frames, so the styling delta is small and lives in the CSS; what is left
       here is the heading copy and where the CTA points. */
    beforeAfter: {
      /* The theme renders both headings and reveals one per breakpoint, so both
         have to be written or the control copy survives on the other one.
         Figma breaks the desktop heading after "Transformations"; the mobile
         frame is a single run that wraps to the same two lines by itself.
         The section's text-transform is `capitalize`, so the casing typed here
         is not the casing that renders. */
      titleDesktop: ['Real Transformations', 'from real people'],
      titleMobile: 'Real Transformations from real people',

      /* The CTA's own copy is already correct in the section settings, and so is
         its target: it points at `severeMulticolumn`. It only looked broken
         because that section ships `hidden`, so in control the link scrolls to a
         collapsed node. The variant reveals it, which makes the stored href
         correct again — but it is still resolved through section() rather than
         trusted, because the rendered id carries a per-theme numeric prefix that
         would rot on the next theme copy. */
      ctaTarget: 'severeMulticolumn'
    },

    /* ── Severe Acne Fixed in Weeks (Figma 10198:4893 / 10198:6955) ──
       Section multicolumn_7kdbNN, moved below the buy box and revealed — see
       CONFIG.moves and the `.before-after--full-cards` block in the CSS, which
       does the reveal, the panel and the track geometry.

       Nothing here is a rewrite: the seven cards are images, the headline and
       its #E16203 "in Weeks" run are already the section's own settings, and the
       arrows are the theme's. The only copy delta is where the mobile heading
       wraps. */
    severe: {
      /* The mobile frame breaks after "Severe Acne"; the theme emits the whole
         line as one run and lets it wrap wherever it lands, which puts "In" on
         the first line. Inserting the break beats rewriting the heading — the
         orange run is already its own element and stays untouched. Matched
         against the rendered text, so a merchant edit makes this no-op instead
         of producing a wrong line. */
      titleMobileBreakAfter: 'Severe Acne'
    },

    /* ── Buy box (Figma 10198:4094 desktop / 10198:6160 mobile) ──
       Section main_product_alt_HFVcpT.

       ⚠️ READ THIS BEFORE COMPARING ANYTHING TO A SCREENSHOT OF THE LIVE PAGE.
       Another Intelligems test (`igtb`) is running on /pages/acne and it
       REPLACES the purchase options with a toggle, adds a price line above them
       and a "Congrats! You're saving $51" bar. None of that is the theme. Block
       Intelligems (qa/buybox-probe.js does) and the theme's own control appears:
       `selling-plans-alt.style-2`, which is already the frame's two-card design
       — badges, prices, the two-column benefit list, the red ✗ and the
       strikethrough, all of it. So the plans are a COPY change, not a rebuild.

       What is genuinely new here is the review card and the FAQ. Everything else
       is copy, order and hiding.

       ⚠️ NOT TOUCHED, ON PURPOSE:
       - The SAVE % badges (22 / 40) are computed from real prices. The frames
         draw 20 / 30 / 22, which was just the discount on the day they were
         drawn. Hardcoding those would ship a wrong number the first time
         pricing moves.
       - The review count in the stars line is Loox's live number. The frame's
         "(7,034)" is a snapshot; only the copy AFTER it is rewritten.
       - The clinician count in the Clinicians' Choice block is injected by
         FrontrowMD and is not in the server HTML at all. Frame says 258, live
         says 643. Same reasoning: leave it. */
    buyBox: {
      /* Which purchase option starts selected.
         ⚠️ THE BRIEF AND THE FRAMES DISAGREE and this is a revenue behaviour, so
         it is a one-word change rather than a decision buried in code:
           · brief:          "Default to Subscription"
           · desktop frame:  One-time selected, CTA reads $99  <- what the theme
                             already does, and the internally consistent frame
           · mobile frame:   One-time drawn as selected, but CTA reads $76
         Left on the theme's behaviour because that is what the desktop frame
         draws. Set to 'subscription' to follow the brief instead. */
      defaultPlan: 'onetime',

      /* Trailing copy only — Loox's live "(7214)" stays. The tail is
         CONFIG.hero.starsText so this cannot drift back to 800,000. */

      /* Copy swaps, matched on the rendered text so a merchant edit makes them
         no-op instead of writing the wrong string into the wrong node. */
      benefitRow: [
        /* ⚠️ Round 3, ticket 5: the newline is load-bearing. Dropping "FAST"
           took the label to 143.69px inside a 151px cell, so it stopped
           wrapping while both its neighbours still run to two lines. The break
           is a `\n` plus `white-space: pre-line` on .rv-benefit__text rather
           than a narrower max-width, because a width tight enough to break
           after "DAYS" is only 6px off breaking after "2-7". normalise()
           collapses whitespace, so the `from` matching is unaffected. */
        { from: 'FAST 2–7 DAYS DELIVERY', to: '2-7 DAYS\nDELIVERY' },
        { from: 'SUBSCRIBE & GET 60-DAY GUARANTEE', to: '60-DAY MONEY BACK GUARANTEE' }
      ],

      /* The subscription card's two-column list. `strong` is the part the theme
         wraps in <strong>; the rest is the tail. Frame order left-to-right is
         30% OFF / FREE SHIPPING / LONG TERM, then LOWEST PRICE / CANCEL OR EDIT
         / OUT OF STOCK — which is the order the theme already renders them in,
         so only the words change. */
      planBenefits: [
        { from: 'GIFTS', strong: '30% OFF', tail: ' all future orders' },
        { from: 'FREE SHIPPING', strong: 'FREE SHIPPING', tail: ' on all orders' },
        { from: 'LONG-TERM', strong: 'LONG TERM', tail: ' healthy skin' },
        { from: 'LOWEST PRICE', strong: 'LOWEST PRICE', tail: ' ever' },
        { from: 'CANCEL OR EDIT', strong: 'CANCEL OR EDIT', tail: ' anytime' },
        { from: 'OUT OF STOCK', strong: 'OUT OF STOCK', tail: ' protection' }
      ],

      /* Frame: "SAVE 40% ON THE FIRST ORDER". The theme writes
         "save {pct}% on your 1st order" from `updateDiscountBadgesFromPercents`
         in selling-plans-alt.js, recomputing it whenever discounts change — so
         only the TAIL is ours and the percentage stays the theme's live number.
         The 40 in the frame happens to be today's real subscription discount;
         hardcoding it would ship a lie the first time pricing moves. */
      subscriptionBadgeTail: 'ON THE FIRST ORDER',

      /* New card in the left column, between the gallery thumbnails and the
         "INSTANT ACNE & REDNESS TREATMENT" block (Figma 10198:4695). */
      /* `star` is the theme's own star, lifted from the rating widget already in
         this section rather than exported again — same path, same #E16203, so
         the card's row cannot drift from the one above the title. The frame
         draws the five as one 94.75x17.029 SVG, i.e. 17.029 tall with 2.4 gaps.
         `check` is the frame's CheckCircle, inlined because an Intelligems paste
         has nowhere to put a file and the MCP asset URL expires in 7 days. */
      icons: {
        star:
          '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6.85762 0L8.47648 4.98235H13.7152L9.477 8.06161L11.0959 13.044L6.85762 9.9647L2.61938 13.044L4.23824 8.06161L0 4.98235H5.23876L6.85762 0Z" fill="#E16203"/></svg>',
        check:
          '<svg viewBox="0 0 15.4 15.4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.69838 13.8601C9.33211 13.8601 10.8989 13.2111 12.0542 12.0559C13.2094 10.9006 13.8584 9.33382 13.8584 7.70009C13.8584 6.06635 13.2094 4.49953 12.0542 3.34431C10.8989 2.18909 9.33211 1.54009 7.69838 1.54009C6.06465 1.54009 4.49783 2.18909 3.3426 3.34431C2.18738 4.49953 1.53838 6.06635 1.53838 7.70009C1.53838 9.33382 2.18738 10.9006 3.3426 12.0559C4.49783 13.2111 6.06465 13.8601 7.69838 13.8601ZM10.5528 6.70448C10.693 6.55925 10.7706 6.36475 10.7689 6.16286C10.7671 5.96097 10.6862 5.76784 10.5434 5.62508C10.4006 5.48231 10.2075 5.40133 10.0056 5.39958C9.80372 5.39782 9.60921 5.47544 9.46399 5.6157L6.92838 8.15131L5.93277 7.1557C5.78755 7.01544 5.59304 6.93782 5.39115 6.93958C5.18926 6.94133 4.99613 7.02231 4.85337 7.16508C4.7106 7.30784 4.62962 7.50097 4.62787 7.70286C4.62612 7.90475 4.70373 8.09925 4.84399 8.24448L6.38399 9.78448C6.52839 9.92883 6.7242 10.0099 6.92838 10.0099C7.13256 10.0099 7.32837 9.92883 7.47277 9.78448L10.5528 6.70448Z" fill="#2D8A5A"/></svg>'
      },

      review: {
        stars: 5,
        headline: 'Changed my confidence completely',
        quote:
          '“I wanted to personally thank you for the impact that you have had on my life. Seriously your product has completely changed my confidence.”',
        initials: 'PS',
        name: 'Preston Shute',
        verified: 'Verified Buyer'
      },

      /* FAQ accordion, inserted after the benefits row (Figma 10198:4869).
         The frame's own annotation reads "Add FAQ accordion below USPs, 5
         entries (copy finalized separately)" and it draws SIX headers with only
         one body. These are the five whose copy is finalized — lifted from
         `01 - IG FAQ PDP Accordions`, same product, already shipped — and
         flattened to this frame's plain style.

         ⚠️ "Shipping & duties" is the sixth header and has no copy anywhere. It
         is deliberately absent, which is also what makes this exactly the "5
         entries" the annotation asks for. Add it here when copy lands.

         ⚠️ THE RITUAL CONTENTS IN BOTH FRAMES ARE WRONG, and the store's own
         handles prove it: `6-in-1-daily-glow-moisturize` is now titled Pimple
         Stopper Day Balm, `acne-redness-killer` is Pimple Stopper Night Balm,
         `premium-face-scrub` is Scrub for Acne Prone Skin. The mobile frame
         lists those three OLD titles; the desktop frame swaps the night balm for
         "Wrinkle & Dark Circle Warrior", a real product that is not in this
         ritual at all. The current titles are used instead — which is also what
         test 01's finalized copy says. */
      faq: [
        {
          id: 'ritual',
          title: "What's in the ritual?",
          open: true,
          blocks: [
            { lines: [
              '1 x Pimple Stopper Day Balm 30 ml // 2-month supply',
              '1 x Pimple Stopper Night Balm 35 ml // 2-month supply',
              '1 x Scrub for Acne Prone Skin 30 ml // 2-month supply'
            ] }
          ]
        },
        {
          id: 'ingredients',
          title: 'Ingredients',
          blocks: [
            { p: 'No fragrance. No harsh sulfates. Just **potent, natural actives that calm irritated, acne prone skin fast**. Nothing that will bleach your towels.' },
            { p: '**Pimple Stopper Day Balm** — led by Sea Buckthorn Oil and Thistle Oil, lightweight actives that control oil and calm breakouts all day, gentle enough for sensitive or sweat stressed skin.' },
            { p: '**Pimple Stopper Night Balm** — led by Sea Buckthorn Extract and Marigold Oil, fast acting, anti inflammatory botanicals that calm redness and fight acne overnight, without the sting or dryness you’d get from benzoyl peroxide or retinoids.' },
            { p: '**Scrub for Acne Prone Skin** — led by Rice Flour and Apricot Kernel Powder, gentle exfoliation that clears dead skin and excess oil without the redness or irritation harsh scrubs cause.' }
          ]
        },
        {
          id: 'guarantee',
          title: 'Acne-free in 60 days or money back',
          blocks: [
            { p: '**Why do we require 60 days of use?** In a clinical study of our ingredients, 79% were completely cured of acne after 60 days.' },
            { p: 'This isn’t a prescription, so there’s no dependency, no withdrawal, and no long term risk to worry about. Just give your skin the full 60 days to reset. Although many of our customers notice overnight effects, sometimes it takes time to clean out all the dirt in your pores and adjust the oil production and elasticity of your skin.' },
            { p: 'These are the guarantee terms you must follow to be eligible for the satisfaction guarantee. The guarantee only applies to rituals, and to subscription orders. Max 1 per customer or order, we refund a maximum of 1x ritual per order or customer. Follow usage instructions, meaning you have used the products as instructed.' },
            { p: 'Steps to claim it. First, fill out the form. Then we will get back to you around 2 weeks after submission.' }
          ]
        },
        {
          id: 'results',
          title: 'What results can I expect?',
          blocks: [
            { lines: [
              '**Week 1:** Redness and irritation start to calm.',
              '**Week 2 to 3:** fewer new breakouts.',
              '**By 30 to 60 days:** clearer, calmer skin for most users.'
            ] },
            { p: 'Results vary for each individual, but **97% of our customers are satisfied with the product’s effects on their acne**, and **93% said it was the best product they ever tried**.' },
            { p: 'Some people report results after just one night, in as little as 8 to 12 hours: less redness, oil production calming down, no new pimples. **Not everyone gets instant results, for some it takes 30 to 60 days**. If breakouts show up around your cycle, give the Ritual a full cycle to see its full effect.' }
          ]
        },
        {
          id: 'howto',
          title: 'How do I use the Kill Acne & Redness Ritual?',
          blocks: [
            { p: 'Two steps, morning and night.' },
            { lines: [
              '**Day Balm** — apply every morning. Light layer, zero water filler, extremely potent.',
              '**Night Balm** — apply every night before bed. For stubborn spots, apply up to 3 to 4 times a day.',
              '**Scrub** — use 2 to 3 times a week in the shower. Dry hands only, mix a pinch with water in your palm, scrub for 1 to 2 minutes. Keep the jar dry, water inside it can cause mold.'
            ] },
            { p: '**Skip everything else: no face washes, no cleansers, no extra steps.**' }
          ]
        }
      ]
    },

    /* ── Clinical trial / scientific claims (Figma 10198:5044 / 10198:7098) ──
       Section long_section_blocks_igTUwg, moved up to sit under the severe-case
       carousel. The brief calls this "Scientific claims — concise redesign", and
       concise is the whole job: the live section is 1659px tall on desktop and
       the frame is a single panel.

       ⚠️ THE FRAME KEEPS ONLY THE FIRST THREE BLOCKS the section renders —
       heading, body copy, and the PubMed strip image — in that order, and drops
       five: the study-page screenshots, a second "Statistically significant…"
       heading, the five-donut image, the "Proven Benefits In 60 Days" block, and
       the promo banner with its countdown timer. Those are hidden in CSS by
       position, so read the note there before adding a block in the admin.

       ⚠️ THE DONUTS ARE NOT IN THE DOM. The live section draws all five as one
       flat PNG (`iws-block-image-*`), at 80/76/90/83/56 — a different set from
       the frame's 80/90/76/69. So they cannot be restyled and are rebuilt here.

       The percentages the frame shows all exist in the live copy: 69% is the
       "Reduced ACNE BREAKOUT frequency BY 68.73%" line from the block the frame
       drops. Nothing was invented. */
    clinicalTrial: {
      /* The ring is decorative, NOT a gauge — I checked. Reversing the arcs
         gives visible-blue fractions of 0.13 / 0.07 / 0.21 / 0.28 against values
         of 80 / 90 / 76 / 69, which is neither the value nor its complement nor
         any constant multiple. So rather than invent a mapping that would look
         "fixed" but disagree with the design, each arc is the frame's own path,
         inlined. Same reasoning as the kit icons: an Intelligems paste had
         nowhere to put a file, and now that this is a theme asset the exactness
         is free. All four share the full circle underneath. */
      ring:
        'M70.2009 130.327C103.408 130.327 130.328 103.407 130.328 70.1997C130.328 36.9923 103.408 10.0723 70.2009 10.0723C36.9935 10.0723 10.0735 36.9923 10.0735 70.1997C10.0735 103.407 36.9935 130.327 70.2009 130.327Z',

      cards: [
        {
          value: '80%',
          lines: ['showed improved', 'acne, dermatologist ‑graded'],
          arc: 'M70.2009 10.0723C36.9935 10.0723 10.0735 36.9923 10.0735 70.1997C10.0735 103.407 36.9935 130.327 70.2009 130.327C103.408 130.327 130.328 103.407 130.328 70.1997C130.328 54.3844 124.222 39.9951 114.239 29.2609'
        },
        {
          value: '90%',
          lines: ['healed with no', 'scarring'],
          arc: 'M70.201 10.0723C36.9935 10.0723 10.0736 36.9923 10.0736 70.1997C10.0736 103.407 36.9935 130.327 70.201 130.327C103.408 130.327 130.328 103.407 130.328 70.1997C130.328 46.6207 116.756 26.2117 96.9976 16.3588'
        },
        {
          value: '76%',
          lines: ['experienced', 'smoother skin'],
          arc: 'M70.2008 10.0723C36.9934 10.0723 10.0734 36.9923 10.0734 70.1997C10.0734 103.407 36.9934 130.327 70.2008 130.327C103.408 130.327 130.328 103.407 130.328 70.1997C130.328 64.4487 129.521 58.8863 128.013 53.6196'
        },
        {
          value: '69%',
          lines: ['reduction in acne', 'breakout frequency'],
          arc: 'M70.2009 10.0723C36.9934 10.0723 10.0735 36.9923 10.0735 70.1997C10.0735 103.407 36.9934 130.327 70.2009 130.327C100.213 130.327 125.089 108.339 129.599 79.5938'
        }
      ],

      /* The frame draws this under the panel with no target. The brief asks for a
         "Read full study" modal with a "Check the complete article" link inside,
         but no modal was designed, so this points at the study page the rest of
         the theme already links to. Swap the href for a modal opener when that
         design lands. */
      readMore: { label: 'Read More →', href: '/pages/clinical-trial' }
    },

    /* ── Ingredients intro (Figma 10198:5234 / 10198:7281) ──
       The brief's "Ingredient-care merge". BUILT FROM SCRATCH, and the live
       `multicolumn_kn8Piy` ("Why mainstream skincare can't copy us") is hidden
       instead of adapted — a deliberate call, not laziness:
         · the frame rewrites all three cards, so adapting preserves no copy;
         · the live card is image + h4 + p inside the theme's
           `moving-from-big-brands` multicolumn variant, which carries its own
           347px max-width, shadows and radii. Reaching the frame's icon-chip
           card from there is more override than markup.
       The three subjects DO survive the rewrite, so nothing is lost:
         WILD-HARVESTED POTENCY   -> OUR INGREDIENTS ARE WILD-SOURCED
         COLD-PROCESSED           -> NORSE IS COLD-PROCESSED, NEVER BOILED
         100% ACTIVE (NO WATER)   -> FULL STRENGTH, NO SHORTCUTS
       `**bold**` runs are rendered by emphasise(), same shorthand as the FAQ. */
    ingredients: {
      heading: ['Ingredients Strong Enough To Stop Breakouts.', 'Gentle Enough To Never Sting.'],

      cards: [
        {
          icon: 'wild',
          title: 'Our ingredients are wild-sourced',
          text: 'Arctic plants survive \u221240\u00b0C winters by building **antioxidant levels 10x higher than ordinary plants**. We harvest that resilience so **it becomes your skin\u2019s defense**.'
        },
        {
          icon: 'cold',
          title: 'Norse is cold-processed, never boiled',
          text: 'Most skincare brands boil their ingredients, killing the nutrients. We don\u2019t. **Every batch is air-dried and cold-blended to keep vitamins and enzymes alive**.'
        },
        {
          icon: 'full',
          title: 'Full strength, no shortcuts',
          text: 'Most lotions list water as the #1 ingredient. Ours has none. No fillers, no dilution, **just full strength ingredients doing the work chemicals usually have to**.'
        }
      ],

      /* Supplied by Mario on the Shopify CDN. The frame shows the same asset in
         both slots, which is a placeholder artefact — these are the real pair. */
      images: [
        { src: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Orange_berries_on_a_snow-covered_branch.webp?v=1786715999',
          alt: 'Sea buckthorn berries on a snow-covered arctic branch' },
        { src: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Orange_berries_on_a_snow-covered_branch-1.webp?v=1786715999',
          alt: 'A Norse Organics harvester holding freshly picked botanicals' }
      ],

      icons: {
        wild:
          '<svg viewBox="0 0 26.6067 23.3582" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><path d="M0.928027 11.6792H25.6784" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.11563 22.43L19.4908 0.928103" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.4908 22.43L7.11563 0.928103" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9605 11.679L23.8996 9.20398" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9605 11.6792L23.8996 14.1542" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1706 5.0275L16.4745 1.2376" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1705 5.02747L20.8057 3.7126" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.43602 5.02747L5.8008 3.7126" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.43598 5.0275L10.1321 1.2376" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.64611 11.6792L2.707 14.1542" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.64611 11.679L2.707 9.20398" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.43598 18.3307L10.1321 22.1206" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.43602 18.3307L5.8008 19.6456" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1705 18.3307L20.8057 19.6456" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1706 18.3307L16.4745 22.1206" stroke="#4F79DD" stroke-width="1.85628" stroke-linecap="round" stroke-linejoin="round"/></g></svg>',
        cold:
          '<svg viewBox="0 0 15.9998 20.5519" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><path d="M4.28169 12.3041C5.67886 12.3041 6.81687 11.1717 6.81687 9.76888C6.81687 8.36608 6.30983 7.74073 5.8028 6.72666C4.71549 4.55767 5.57745 2.61967 7.83094 0.64786C8.33798 3.18304 9.85909 5.61118 11.8816 7.2337C13.9097 8.85621 14.9238 10.7829 14.9238 12.8055C14.9238 16.7209 11.7464 19.8983 7.83094 19.8983C3.9155 19.8983 0.738071 16.7265 0.738071 12.8111C0.738071 11.6449 1.1775 10.4844 1.75214 9.76888C1.75214 11.166 2.88452 12.3041 4.28732 12.3041H4.28169Z" stroke="#4F79DD" stroke-width="1.30139" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.676177 19.4307L15.3239 4.783" stroke="#4F79DD" stroke-width="1.3521" stroke-linecap="round"/></g></svg>',
        full:
          '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><path d="M9 1.5C11.25 4.5 13.5 7.125 13.5 9.75C13.5 10.9435 13.0259 12.0881 12.182 12.932C11.3381 13.7759 10.1935 14.25 9 14.25C7.80653 14.25 6.66193 13.7759 5.81802 12.932C4.97411 12.0881 4.5 10.9435 4.5 9.75C4.5 7.125 6.75 4.5 9 1.5Z" stroke="#2F6FED" stroke-width="1.5" stroke-linecap="round"/><path d="M2.25 2.25L15.75 15.75" stroke="#2F6FED" stroke-width="1.5" stroke-linecap="round"/></g></svg>'
      }
    },

    /* ── Always Free From (Figma 10198:5282 / 10198:7330) ──
       The brief's "Trust badges". ENTIRELY NEW: grepping the rendered page and
       the whole theme for "always free from" or a free-from section type returns
       nothing, so there was nothing to reposition or adapt.

       ⚠️ THE TWO FRAMES DISAGREE ABOUT WHICH LABEL BELONGS TO WHICH ICON.
       Desktop pairs the DNA helix with "NON GMO" and the molecules with "NO
       HORMONE DISRUPTORS"; mobile swaps them. Desktop is the semantically
       correct pairing and is used at both breakpoints. The mobile frame also
       reorders the six (hormone moves 6th -> 4th); one order is kept everywhere
       instead, so the list below is the single source of truth. Flagged for
       Mario rather than guessed at.

       Icons: four are whole SVGs from the frame. The other two are a #4F79DD
       disc with a white ring and glyph on top, which Figma exports as separate
       pieces — they are recomposed here into one SVG per badge, with the disc as
       a <circle> and each piece translated by the frame's own offsets (every
       piece exports at scale 1, so only the translation was derived). Rendered
       and eyeballed against the frame before committing. */
    trustBadges: {
      heading: 'Always Free From',

      badges: [
        /* ⚠️ Ticket 11 switched this to the MOBILE frame's order, which moves
           "no hormone disruptors" from last to third. Earlier in the build the
           desktop order was chosen instead, on the reasoning that the mobile
           frame looked stale — the ticket settles it the other way.

           ⚠️ THE ICON PAIRING IS STILL DESKTOP'S, DELIBERATELY. The mobile frame
           also swaps which icon carries which label, giving the DNA helix to
           "no hormone disruptors" and the molecules to "non GMO". That is
           backwards, so the order comes from mobile and the pairing does not. */
        /* ⚠️ Round 2, ticket 3: split onto two rows. It was the only badge on one
           line, so on mobile its icon sat 21px higher than the other five in the
           same grid row. `lines` already drives a <br> per entry — no CSS needed. */
        { icon: 'clinical',   lines: ['Clinically', 'Tested'] },
        { icon: 'natural',    lines: ['100% natural /', 'no chemicals'] },
        { icon: 'hormone',    lines: ['No hormone', 'disruptors'] },
        { icon: 'gmo',        lines: ['NON', 'GMO'] },
        { icon: 'pesticides', lines: ['No pesticides /', 'herbicides'] },
        { icon: 'water',      lines: ['No water,', 'fillers or BS'] }
      ],

      icons: {
        clinical:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><rect width="102.96" height="102.96" rx="51.48" fill="#4F79DD"/><g></g><path d="M60.1509 22.2178C60.8133 22.335 61.2194 22.8431 61.2144 23.4502V23.4512C61.2092 24.0663 60.7394 24.5948 60.1147 24.6523L59.2417 24.7324L59.2427 25.6084L59.2437 35.6094C59.2437 36.0606 59.3767 36.4706 59.5034 36.7861L59.6226 37.0684L72.4478 66.5986L72.4487 66.5996L73.7007 69.4697C74.4009 71.0748 74.7035 72.6609 74.4067 74.3154C73.811 77.6361 71.0114 80.28 67.6948 80.2822L36.3667 80.2969C34.7073 80.2974 33.1347 79.6239 31.8862 78.4756C29.6986 76.4634 28.7772 73.1847 29.9604 70.4326V70.4316L37.6333 52.584L44.5991 36.6025C44.7685 36.2147 44.8341 35.84 44.8569 35.4961L44.8677 35.1631L44.9106 25.6123L44.9146 24.7227L44.0278 24.6514C43.4684 24.6062 43.0091 24.1361 42.9526 23.5742L42.9468 23.4609C42.9458 22.8257 43.3547 22.3262 44.0093 22.2178H60.1509Z" stroke="white" stroke-width="1.92"/></g></svg>',
        natural:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><rect width="102.96" height="102.96" rx="51.48" fill="#4F79DD"/><g></g><g><path d="M51.9802 71.0809C41.578 71.0809 33.1428 62.2825 33.1428 51.4268C33.1428 35.8445 51.9802 17.5501 51.9802 17.5501C51.9802 17.5501 70.8176 35.8445 70.8176 51.434C70.8176 62.2896 62.3824 71.088 51.9802 71.088" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/><path d="M51.9789 32.4216V84.9681" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/><path d="M46.0302 40.353L51.9788 46.3016" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/><path d="M42.0648 52.2507L51.9792 62.1651" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/><path d="M57.9275 40.353L51.9789 46.3016" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/><path d="M61.8933 52.2507L51.9789 62.1651" stroke="white" stroke-width="2.02254" stroke-linecap="round" stroke-linejoin="round"/></g></g></svg>',
        gmo:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><rect width="102.96" height="102.96" rx="51.48" fill="#4F79DD"/><g></g><g clip-path="url(#clip0_0_46)"><path d="M51.9797 82.8753C69.3894 82.8753 83.5027 68.7217 83.5027 51.2622C83.5027 33.8028 69.3894 19.6491 51.9797 19.6491C34.57 19.6491 20.4566 33.8028 20.4566 51.2622C20.4566 68.7217 34.57 82.8753 51.9797 82.8753Z" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><path d="M74.6131 28.5583L29.346 73.9547" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><g><g><path d="M74.6131 63.5607C72.9613 60.6396 69.3046 59.4446 65.9569 59.413C62.6091 59.3814 59.2992 60.2413 55.9515 60.2919C52.6037 60.3424 49.4262 58.9451 47.0557 56.5678C44.6851 54.1905 43.2918 51.0103 43.3422 47.6466C43.3927 44.283 44.2564 40.9699 44.2186 37.6126C44.1808 34.2553 42.9955 30.5882 40.0828 28.9316" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><path d="M63.8714 73.5714C60.9587 71.9149 59.7671 68.2478 59.7356 64.8904C59.7041 61.5331 60.5615 58.2137 60.6119 54.8564C60.6624 51.4991 59.2691 48.3125 56.8985 45.9352C54.528 43.5579 51.3568 42.1606 48.0027 42.2112C44.6487 42.2618 41.345 43.128 37.9973 43.09C34.6495 43.0521 30.9929 41.8634 29.3411 38.9424" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/></g><path d="M70.7537 60.3343L60.7546 70.362" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><path d="M42.4891 31.9954L32.4963 42.0168" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/></g></g></g><defs><clipPath><rect width="64.9375" height="65.123" fill="white" transform="translate(19.5112 18.6973)"/></clipPath></defs></svg>',
        pesticides:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle cx="51.48" cy="51.48" r="51.48" fill="#4F79DD"/><g transform="translate(19.914 19.194)"><g><path d="M32.068 63.1359C49.2263 63.1359 63.1359 49.2263 63.1359 32.068C63.1359 14.9096 49.2263 1 32.068 1C14.9096 1 1 14.9096 1 32.068C1 49.2263 14.9096 63.1359 32.068 63.1359Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/><path d="M54.0104 10.1259L10.13 54.0063" stroke="white" stroke-width="2" stroke-miterlimit="10"/></g></g><g transform="translate(40.695 35.098)"><g><path d="M14.0548 5.39777H10.5751H7.10175L1 14.6498V25.4863V36.3228H10.5751H20.1565V25.4863V14.6498L14.0548 5.39777Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5719 24.2187V5.39777" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><g><path d="M8.44378 1V5.39922" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.7108 1.00003V5.39925" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></g></g><g transform="translate(43.966 28.865)"><g><path d="M1 4.79651L5.88388 1H16.3227V3.51029L10.5627 6.76621H1V4.79651Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.5551 1.00004V3.22451" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></g></svg>',
        water:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle cx="51.48" cy="51.48" r="51.48" fill="#4F79DD"/><g transform="translate(19.482 18.669)"><g><path d="M32.4985 64.2017C49.9082 64.2017 64.0216 50.048 64.0216 32.5886C64.0216 15.1291 49.9082 0.975453 32.4985 0.975453C15.0888 0.975453 0.975453 15.1291 0.975453 32.5886C0.975453 50.048 15.0888 64.2017 32.4985 64.2017Z" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><path d="M54.7623 10.2626L10.2391 54.9129" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/></g></g><g transform="translate(31.348 30.587)"><g><path d="M15.1115 8.68887L8.66076 15.1581L23.9563 30.4973L30.407 24.0281L15.1115 8.68887Z" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M29.0619 25.4128L25.3439 29.1415L29.1154 32.9237L32.8334 29.1951L29.0619 25.4128Z" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.86215 3.15015L3.14415 6.87877L10.0363 13.7906L13.7543 10.062L6.86215 3.15015Z" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M30.9769 31.0604L37.7607 37.8636" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.975453 9.04944L9.02644 0.975453" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.30895 17.5224L17.4744 6.32506" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.7072 14.2909L18.9293 16.0739" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.006 20.6102L25.2281 22.3869" stroke="white" stroke-width="1.95091" stroke-linecap="round" stroke-linejoin="round"/></g></g></svg>',
        hormone:
          '<svg viewBox="0 0 102.96 102.96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g><rect width="102.96" height="102.96" rx="51.48" fill="#4F79DD"/><g></g><g clip-path="url(#clip0_0_26)"><path d="M51.9797 82.8744C69.3894 82.8744 83.5027 68.7207 83.5027 51.2612C83.5027 33.8018 69.3894 19.6481 51.9797 19.6481C34.57 19.6481 20.4566 33.8018 20.4566 51.2612C20.4566 68.7207 34.57 82.8744 51.9797 82.8744Z" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><path d="M74.6131 28.5573L29.346 73.9537" stroke="white" stroke-width="1.95091" stroke-miterlimit="10"/><g clip-path="url(#clip1_0_26)"><path d="M64.0864 53.3971L54.8756 54.6852L51.3809 63.2865L57.1006 70.5948L66.3113 69.3067L69.8024 60.7102L64.0864 53.3971Z" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M49.0209 47.397L39.8102 48.6851L36.319 57.2815L42.0351 64.5946L51.2458 63.3065L54.7405 54.7053L49.0209 47.397Z" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M46.7959 31.4871L37.5852 32.7752L34.0946 41.3758L39.8101 48.6848L49.0209 47.3966L52.5161 38.7996L46.7959 31.4871Z" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M69.7998 60.7114L74.4824 60.0566" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M66.309 69.307L69.4739 73.4086" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M42.0329 64.5946L40.0714 69.1288" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M36.3175 57.2806L31.6349 57.9355" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M52.587 38.7905L57.2696 38.1357" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M57.5978 57.5591L62.2762 56.9048" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M38.2391 41.0202L41.1455 44.7336" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M34.5761 29.0746L37.4784 32.7886" stroke="white" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></g></g></g><defs><clipPath><rect width="64.9375" height="65.123" fill="white" transform="translate(19.5112 18.6963)"/></clipPath><clipPath><rect width="50" height="43.4046" fill="white" transform="translate(70.0076 23.4833) rotate(82.0388)"/></clipPath></defs></svg>'
      }
    },

    /* ── Built to clear acne fast (Figma 10198:5368 / 10198:7417) ──
       Section norse_ingredients_section_fNy7m3.

       ⚠️ THIS IS "THE PRIOR A/B TEST BUILD" THE BRIEF SAID TO REUSE, and it was
       never missing — it is in the theme, complete, with `hidden` on
       `.ni-section`. Three tabs, all thirteen ingredients with copy that already
       matches the frames, the images, the CTA and the guarantee line. MEMORY's
       open question 2 is answered: it did not live in another test folder.

       So this is a reveal plus a handful of deltas, not a build.

       ⚠️ THE TWO FRAMES DISAGREE ON CARD ORDER. Desktop opens Day Balm with
       Eucalyptus and Rosehip; the mobile frame lists Arnica, Thistle, Vitamin E,
       Rosehip, Eucalyptus — which is exactly what the section already renders.
       The desktop frame is taken as the intended change and applied at both
       breakpoints: a mobile frame that matches the existing build byte for byte
       reads as "not re-ordered yet", and this file has caught the mobile frame
       being the stale one three times now (old product names, the wrong CTA
       price, swapped badge labels). One order, not two. Flagged for Mario. */
    builtToClear: {
      /* Desired order per tab, BY NAME. Matched against the rendered card title
         and applied as flex `order`, so nothing moves in the DOM and a copy edit
         in the admin drops that card to the end instead of scrambling the rest. */
      order: {
        day: ['Eucalyptus', 'Rosehip', 'Arnica', 'Thistle', 'Vitamin E'],
        night: ['Beta-Carotene', 'Sea Buckthorn', 'Marigold', 'Lavender', 'Borage Seed Oil'],
        scrub: ['Rice Powder', 'Rose Petal Powder', 'Apricot Seed Powder']
      },

      /* Optimised art supplied by Mario 2026-08-14, keyed BY INGREDIENT NAME.
         The filenames carry no clue — they are all `Group_14845821xx` — so each
         was downloaded and identified by eye against the frames and Mario's own
         tab screenshots before being mapped here. All thirteen matched with no
         ambiguity; if a re-export ever lands, do the same rather than trusting
         the order of the list you are given. */
      images: {
        'Eucalyptus':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582111.webp?v=1786717994',
        'Rosehip':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582111-1.webp?v=1786717994',
        'Arnica':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582110.webp?v=1786717994',
        'Thistle':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582110-1.webp?v=1786717995',
        'Vitamin E':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582111-2.webp?v=1786717993',
        'Beta-Carotene':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582110-2.webp?v=1786717993',
        'Sea Buckthorn':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582109.webp?v=1786717994',
        'Marigold':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582109-1.webp?v=1786717994',
        'Lavender':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582111-3.webp?v=1786717994',
        'Borage Seed Oil':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582109-2.webp?v=1786717994',
        'Rice Powder':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582109-3.webp?v=1786717993',
        'Rose Petal Powder':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582110-3.webp?v=1786717994',
        'Apricot Seed Powder':
          'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Group_1484582109-4.webp?v=1786717994',
      },

      /* ⚠️ Ticket 2. The Face Scrub frame gives Rose Petal Powder the SAME
         sentence as Marigold, which earlier in the build looked like a
         copy-paste slip in the design — so the section's own distinct line
         ("Inhibits acne bacteria by 75%…") was kept and the conflict flagged.
         The ticket confirms the frame is right, so the frame's copy wins.
         Keyed by name and applied with rewrite(), so it restores on failsafe. */
      copy: {
        'Rose Petal Powder':
          'Fast-working acne fighter shown to reduce acne by 78% and calm inflammation.'
      },

      // the frame annotates this one "copy change": & rather than -
      cta: 'Try it risk-free & save 40%',

      // frame uses the emoji; the section ships a green ✓ glyph
      guaranteeIcon: '\u2705'
    },

    /* ── Why Norse Customers Get Results Faster (Figma 10198:5422 / 10198:7485) ──
       The brief's "comparison table". BUILT FROM SCRATCH, and MEMORY's open
       question 3 is answered: the control's `long_section_blocks_xKFYLj` is a
       heading block plus a flat PNG of the whole table (Frame_1984078976…png,
       one export per breakpoint). There is no table markup on this page to
       restyle, so "restyle per Figma" means building one.

       ⚠️ WHY THE SECTION IS HIDDEN RATHER THAN ADAPTED. Only the heading STRING
       survives the redesign, and keeping the section costs five forced
       overrides — all of them against ID selectors the section emits inline:
         #iws-blocks-…__long_section_blocks_xKFYLj  background-image (the
             yellow→orange gradient; the frame is white)
         #iws-blocks-… .iws-blocks-container       max-width: 930px — and the
             frame's table is 1014 WIDE, so this one is not cosmetic
         #block-heading_block_RBVEyi .iws-block-heading
             font-weight: 600 !important (the PP Mori fake-bold trap; frame
             wants 500) and the stored colour #b0510e (frame is black)
         plus hiding the image block.
       Same call, for the same reason, as `bigBrands` under CONFIG.ingredients.

       ⚠️ THE TWO FRAMES DISAGREE ON FOUR COLOUR TOKENS. Desktop / mobile: rule
       #e6ddcd / #e7e7e7, tick chip #2fa84f / #22a64f, cross chip #484848 /
       #3d3d3d, "typical" text #757575 / #6b6b6b — and #969696 again for the
       mobile column caption, so the mobile frame does not agree with itself.
       Desktop is used at both breakpoints, which is how this file has settled
       every other frame disagreement: one source of truth, flagged for Mario
       rather than guessed at.

       Copy that shortens on mobile is NOT in that bucket — the column captions
       genuinely cannot fit, so they carry a `…Short` form that CSS swaps in
       (see cmpText()). That is the ONLY place it is needed:

       ⚠️ "Zero side-effects" / "No side-effects" was tried as a `…Short` pair
       and REVERTED — do not redo it. The mobile cell has 92px of text column
       and BOTH strings break at the hyphen, so the shortening buys no line and
       changes nothing on screen. Desktop's stronger wording is used at both
       breakpoints; the difference is a copy call for Mario, not a layout one.

       ⚠️ More generally, the mobile frame's line breaks are not a wrapping
       spec. Its text boxes are hand-dragged narrower than their own content —
       "Side-effects" is a 79px box around 79px of text reported 34 tall, i.e.
       two lines — so the frame wraps in places the real 92px column does not,
       and vice versa. Four of the six good cells break exactly as the frame
       draws them and two do not, in OPPOSITE directions, which is the tell.
       Natural wrapping is used, as it was for "Clinically / Tested" on the
       trust badges.

       ⚠️ Desktop also sets three cells in Inter rather than PP Mori ("Zero
       side-effects", "Controls symptoms", "Chemicals that are hormone
       disruptors"). Every neighbouring cell in the same visual row is PP Mori
       and the render shows one face throughout, so that is a Figma slip, not a
       mixed-type design. PP Mori everywhere. */
    resultsTable: {
      /* The frame applies `text-transform: capitalize` over sentence case, so
         the copy is stored the way the frame's text node holds it. */
      heading: 'Why Norse customers get results faster',

      /* Both exports are the Figma NODE at 3x, not the source fills, so each one
         already carries the frame's own crop: 987x568 against a 328.823x189.221
         slot (1.7377 vs 1.7378) and 696x582 against 232x194 (1.1959 vs 1.1959).
         They drop straight into the slot at both breakpoints — do not re-crop. */
      columns: {
        good: {
          label: 'Norse Organics Formulation',
          labelShort: 'Norse',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Frame_1984079217.webp?v=1786718859',
          alt: 'The three Norse Organics tins: Pimple Stopper Day Balm, Night Balm and Scrub for Acne Prone Skin'
        },
        bad: {
          label: 'Typical Treatments',
          labelShort: 'Typical',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/image_199.webp?v=1786718858',
          alt: 'A cluster of typical drugstore acne creams, gels, washes and serums'
        }
      },

      rows: [
        { label: 'How it works',      good: 'Works in days',                  bad: 'Works in months' },
        { label: 'Customer response', good: '97% satisfaction',               bad: 'Only 20–30% see results' },
        { label: 'Side-effects',      good: 'Zero side-effects',              bad: 'Blemishes come back fast' },
        { label: 'Actions',           good: 'Treats the root cause',          bad: 'Controls symptoms' },
        { label: 'Results',           good: 'Supports your overall health',   bad: 'Chemicals that are hormone disruptors' },
        { label: 'Ingredients',       good: '0 fillers, 0 water, 0 chemicals', bad: '70–80% water and cheap fillers' }
      ],

      /* One viewBox for both breakpoints — the two exports are the same geometry
         at different scales (desktop `M10 3L4.5 8.5L2 6` in 12 units is the
         mobile path in 9 units multiplied by 12/9). The STROKE is not a constant
         ratio, though: 1.75/12 desktop against 1.5/9 mobile, so the width is set
         from CSS per breakpoint rather than baked in here. */
      icons: {
        tick:  '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M10 3L4.5 8.5L2 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        cross: '<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M3 3L9 9M9 3L3 9" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      }
    },

    /* ── "..using this less than 1 WEEK" (Figma 10198:5554 / 10198:7637) ──
       Section review_testimonial_mCyMnK. The brief: keep it, change the
       background, add a CTA reading "Solve yours now" with 40% messaging.

       **Almost all of this already ships.** `review-testimonial` renders a
       title, a DESKTOP image and a separate MOBILE image with the theme
       switching them at 750, and a CTA block — and the CTA block already exists
       on this section (`cta_QArpRy`, `#killAcneSection`, which is a real anchor
       on this page: `id="killAcneSection"` appears once in the rendered HTML).
       So the "add CTA" in the brief is a copy change, and the whole job is two
       image swaps, one string, and styling.

       The TITLE is not touched either: the stored richtext is already
       `"..using this less than 1 WEEK"` and the theme already applies
       `text-transform: capitalize`, which is exactly what the frames draw.

       ⚠️ The mobile frame's button reads "Solve yours now % save 40%" — a `%`
       where the desktop frame has `&`. Typo in the frame, not a copy decision.

       Both images are the composed Figma nodes, exported by Mario:
         Frame_1984079865  2280x1758 -> the desktop row at 1140x879  (1.2969)
         Container         1050x2106 -> the mobile block at 345x698.83 (0.4986)
       The desktop export is the WHOLE row — avatar, review bubble and the
       progress collage — not just the collage, so it drops into the existing
       single-<img> slot with no markup change. */
    lessThanOneWeek: {
      images: {
        desktop: {
          src: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Frame_1984079865.webp?v=1786721124',
          width: 2280,
          height: 1758
        },
        mobile: {
          src: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Container.webp?v=1786721124',
          width: 1050,
          height: 2106
        }
      },
      /* The theme's `.cta-button__text` is already `text-transform: uppercase`,
         so this is stored as the frame's own sentence case and rendered upper —
         which keeps it readable here and translatable later. */
      alt: 'Dana Gronberg’s review beside her son’s progress photos over four weeks',
      cta: 'Solve yours now & save 40%'
    },

    /* ── Final section: guarantee + founder, merged (10198:5566 / 10198:7648) ──
       The brief: "merge money-back guarantee + founder into one".

       **`why_trust_us_CGH9ng` is the host, and it is already most of the
       frame.** It ships the title verbatim ("Why Trust Us When You Tried
       Everything And Everyone Lied?"), the founder's body copy, the author line
       verbatim ("Daniel Hoftun, Founder Norse Organics"), the signature image —
       which is literally the asset the Figma node points at, filename and all —
       and BOTH image slots, desktop and mobile.

       The three things it lacks are exactly the three that live in the section
       being merged INTO it, `founders_note_xtDULX`:
         eyebrow  `p.founders-note__subtitle`  "Founders note"
         quote    `h2.founders-note__title`    "If We Don't Help You, We Don't
                                                Want Your Money!" — verbatim
         CTA      `.founders-note__cta`        an <a> to #killAcneSection

       They are BUILT here rather than moved across sections: three short nodes
       against DOM moves plus undo bookkeeping plus the founders-note CSS that
       would travel with the classes. `foundersNote` goes in CONFIG.hide, so the
       founder is not printed twice.

       ⚠️ The frame REWRITES the body copy — three condensed paragraphs against
       the live section's five, with every <strong> run dropped. That is a real
       copy change, not a restyle, so it is stored here in full.

       The image is Mario's export of the frame's whole right column: BOTH
       photos and the 18px gap between them, at 1110x1316 = exactly 2x the
       frame's 555x658 slot. The rounded corners and the gap are baked in as
       transparency (corner and mid-gap pixels sample alpha 0), so there is no
       radius to set and no second <img> to build. */
    finalSection: {
      eyebrow: 'Founders note',

      /* Ticket 6: the title runs "Why Trust Us When You Tried Everything And
         Everyone Lied?" and has to break after "Everything". Inserted rather
         than rewritten — the copy is the section's, and matching on the rendered
         text means a merchant edit makes this a no-op instead of a wrong break.
         Same shape as the severe carousel's mobile heading. */
      titleBreakAfter: 'Everything',

      /* Verbatim from founders_note_xtDULX, which this merge absorbs. */
      quote: '"If we don’t help you, we don’t want your money!"',

      body: [
        'I know how exhausting this journey is. If you’re reading this, you’ve probably tried the benzoyl peroxide that bleached the towels. The antibiotics that upset the stomach. The retinols that made skin peel and burn. Maybe you’ve even considered the heavy-hitters like Accutane, but you’re terrified of the side effects.',
        'I lived that frustration. I spent years trusting products that only offered harsh chemicals and disappointment. That’s why Norse Organics exists: we stripped away the fillers, the water, and the synthetic toxins, and replaced them with pure, wild-harvested arctic plants. Powerful enough to heal cystic acne. Safe enough to eat.',
        'I’m not asking you to trust a corporation. I’m asking you to trust a founder who’s stood exactly where your teen is standing right now. I’m so confident this works that if you don’t see results in 60 days, I’ll refund every penny. No forms, no tricks, no questions asked.'
      ],

      /* ⚠️ ONE export for both breakpoints, and it is exact on desktop only.
         The frames disagree about the right column's shape: desktop stacks two
         320-tall images with an 18 gap in 555 (ratio 0.843), mobile two 207s
         with a 20 gap in 345 (0.795). The export is the desktop column, so at
         345 it renders 409 tall against the mobile frame's 434 — 6% short.
         Rendered at its own ratio rather than stretched; a second export cut to
         the mobile proportions is the only way to close it. */
      image: {
        src: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/Frame_1984079866.webp?v=1786721808',
        width: 1110,
        height: 1316
      },
      alt: 'Two tins of Norse Organics balm on driftwood, and founder Daniel Hoftun carrying his child on his shoulders',

      cta: 'Try it risk-free & save 40%',
      /* the same in-page anchor every other CTA on this page uses; it resolves —
         `id="killAcneSection"` appears once in the rendered document */
      ctaHref: '#killAcneSection'
    },

    /* ── Trusted by Leading Doctors & Mothers (Figma 10198:3966 / 10198:6031) ──
       Section norse_ambassador_section_LfJD6C.

       The cards are rendered from the `ambasadors` METAOBJECT, not from section
       blocks — see sections/norse-ambassador-section.liquid. A theme can only
       read metaobjects, and editing this one in the admin would change the
       control arm too and destroy the comparison, so the copy and the avatars
       are rewritten in the DOM from here. */
    doctorsMothers: {
      /* THE ORDER HERE IS THE RENDERED ORDER, and this list is the whole cast.
         The metaobject holds Christina Milian, Dr. Jaban Moore and Meredith
         Masony — so only one of the frame's three people actually exists on the
         page. The module builds the missing cards by cloning a rendered one and
         hides whoever is not listed here.

         Adding Jessica and Jennie to the metaobject in the admin would have been
         the obvious fix and is the wrong one: it would put them in the CONTROL
         arm too, and there would be nothing left to measure. */
      people: [
        {
          name: 'Jessica Capshaw',
          position: 'Actress & Mother',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/div.advisory__avatar.webp?v=1786411121',
          bio: [
            '"These balms are made from arctic plants that grow miles away from pollution in the freezing North. This is the cleanest, most biologically active nutrient source for your teen’s skin on the planet. They explode with antioxidants!"'
          ]
        },
        {
          name: 'Jennie Garth',
          position: 'Actress & Mother',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/div.advisory__avatar-1.webp?v=1786411121',
          // one entry per paragraph; the module joins them with a blank line
          bio: [
            'I’ve been in this industry long enough to know when something is BS and when it’s the real deal.',
            'This is the real deal. Norse Organics has been a game-changer in our house. It’s organic, it’s effective, and it calms acne so, so fast! 💞'
          ]
        },
        {
          name: 'Dr. Jaban Moore',
          position: 'Functional Medicine Doctor',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/div.advisory__avatar-2.webp?v=1786411121',
          bio: [
            'My #1 Acne solution is Norse Organics! I especially love Mountain Arnica. It has some of the most potent anti-inflammatory compounds in the world. Sea Buckthorn produces antimicrobial lipids that work on acne bacteria without touching a single beneficial microbe. Arctic Rosehip rebuilds the skin barrier in 1-2 weeks.'
          ]
        }
      ],

      /* The frame only draws the collapsed state, so the expanded label is ours.
         Kept here so it is one edit if design specifies something else. */
      readMore: 'Read More →',
      readLess: 'Read Less'
    },

    /* ── So Simple It Fits Anyone's Routines (Figma 10198:4034 / 10198:6098) ──
       A NEW section — nothing on the template renders this — built and inserted
       after the Doctors & Mothers band.

       SHADOWS ARE BAKED INTO THE ASSETS. Figma draws each jar as a tight box
       with a four-layer drop shadow around it; the supplied files already carry
       that shadow, so the <img> has to be bigger than the Figma node by exactly
       the shadow's reach and sit offset behind it. `bleed` is that reach as a
       PERCENTAGE of the node. For a shadow with no spread it is `blur - offset`
       on the near sides and `offset + blur` on the far ones:

         day    21.511/22.855/5.042 · 13.444/12.1/5.042 ·
                2.689/4.033/10.419 · 6.05/6.05/7.731
                -> l 7.730  t 6.386  r 26.553  b 27.897   of 187.549 x 167.969
         night  26.889/28.569/6.302 · 16.806/15.125/6.302 ·
         scrub  3.361/5.042/13.024 · 7.562/7.562/9.663
                -> l 9.663  t 7.982  r 33.191  b 34.871

       Percentages rather than px because the two frames are the same shape at a
       different scale (187.549/104.413 = 1.7963, and every shadow value scales
       by that same factor) — so one set of numbers serves both breakpoints, and
       CSS resolves left/width against the box width and top/height against its
       height. Verified against the files: node+bleed reproduces each asset's
       aspect ratio to within a tenth of a percent (888x809, 922x844, 922x844). */
    kitRoutine: {
      heading: 'So simple it fits anyone’s routines',
      // the frame annotates "Remove ':' after 'For'" — this copy already has none
      pill: 'For woman & men, teens & adults',

      products: [
        {
          name: 'Pimple Stopper Day Balm',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/DSC07254_1.webp?v=1786417552',
          bleed: { l: 4.1216, t: 3.8019, r: 14.158, b: 16.6085 },
          icon: 'sun',
          badge: 'Use every morning',
          text: 'Blocks the dirt, oil, and bacteria behind breakouts.'
        },
        {
          name: 'Pimple Stopper Night Balm',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/DSC07254_2_b2f8171b-fd85-4c20-a51e-da3e697b357b.webp?v=1786417552',
          bleed: { l: 5.1523, t: 4.7521, r: 17.697, b: 20.7605 },
          icon: 'moon',
          badge: 'Use before bed',
          text: 'Calms redness and repairs skin while you sleep.'
        },
        {
          name: 'Scrub for Acne Prone Skin',
          image: 'https://cdn.shopify.com/s/files/1/0485/7787/2027/files/DSC07254_2-1_91bbda8d-0300-4b63-bb77-be270f55865d.webp?v=1786417552',
          bleed: { l: 5.1523, t: 4.7521, r: 17.697, b: 20.7605 },
          icon: 'scrub',
          badge: '3× a week in the shower',
          text: 'Clears clogged pores before they cause breakouts.'
        }
      ],

      /* Same geometry as the icons in `01 - IG FAQ PDP Accordions`, drawn at a
         different viewBox scale (sun 27.2774/24 = 1.1366 against
         13.6383/11.9999 = 1.1365). Reused rather than re-exported; the width and
         height attributes are stripped so the badge can size them by height. */
      icons: {
        sun:
          '<svg viewBox="0 0 27.2774 27.2779" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M13.6383 21.0115C17.7101 21.0115 21.011 17.7106 21.011 13.6388C21.011 9.56698 17.7101 6.26611 13.6383 6.26611C9.56649 6.26611 6.26562 9.56698 6.26562 13.6388C6.26562 17.7106 9.56649 21.0115 13.6383 21.0115Z" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.6387 3.10648V1" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.6387 24.1714V26.2779" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.10648 13.6389H1" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.1709 13.6389H26.2774" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.21379 6.21355L4.73926 4.73901" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.0645 6.21355L22.539 4.73901" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.21379 21.0642L4.73926 22.5387" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.0645 21.0642L22.539 22.5387" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        moon:
          '<svg viewBox="0 0 19.0001 25.6787" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M18 2.18394C16.1951 1.30979 14.1977 0.908435 12.1953 1.01754C10.1928 1.12664 8.25085 1.74261 6.55161 2.80768C4.85236 3.87274 3.45151 5.352 2.48047 7.10666C1.50942 8.86133 1 10.8339 1 12.8394C1 14.8448 1.50942 16.8174 2.48047 18.572C3.45151 20.3267 4.85236 21.806 6.55161 22.871C8.25085 23.9361 10.1928 24.5521 12.1953 24.6612C14.1977 24.7703 16.1951 24.3689 18 23.4948C15.174 23.4948 12.4638 22.3721 10.4655 20.3739C8.46721 18.3756 7.34459 15.6653 7.34459 12.8394C7.34459 10.0134 8.46721 7.30311 10.4655 5.30484C12.4638 3.30656 15.174 2.18394 18 2.18394Z" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        scrub:
          '<svg viewBox="0 0 22 23.8183" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M17.3636 1H8.27266C7.2685 1 6.45447 1.81403 6.45447 2.81819V3.72728C6.45447 4.73144 7.2685 5.54547 8.27266 5.54547H17.3636C18.3678 5.54547 19.1818 4.73144 19.1818 3.72728V2.81819C19.1818 1.81403 18.3678 1 17.3636 1Z" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.45456 3.27291C2.81819 3.27291 1 4.93958 1 8.27292V12.8184" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.1818 5.54539H6.4545C5.45034 5.54539 4.63631 6.35942 4.63631 7.36358V9.18177C4.63631 10.1859 5.45034 11 6.4545 11H19.1818C20.186 11 21 10.1859 21 9.18177V7.36358C21 6.35942 20.186 5.54539 19.1818 5.54539Z" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.27262 12.8184V15.5457" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.8184 12.8184V15.5457" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.3634 12.8184V15.5457" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.5" d="M6.00014 16.4547V19.182" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.5" d="M10.5451 16.4547V19.182" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.5" d="M15.0909 16.4547V19.182" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.5" d="M19.6367 16.4547V19.182" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.25" d="M8.27262 20.0911V22.8183" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.25" d="M12.8184 20.0911V22.8183" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path opacity="0.25" d="M17.3634 20.0911V22.8183" stroke="#E16203" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      }
    }
  };

  var P = CONFIG.prefix;
  /* Resolved on every use, NOT captured once at parse time.
     ⚠️ This bit the test: `var docEl = document.documentElement` reads null when
     the script is evaluated before the <html> element is parsed. Intelligems
     normally injects into <head>, where documentElement already exists — but any
     injector that runs earlier (a document_start userscript, some tag managers,
     a preview harness) made the very first statement of start() throw, which
     failsafed the WHOLE test before a single class was added. Symptom: the page
     is byte-identical to control and nothing in it looks broken, so it reads as
     "the test stopped working" rather than as an error.
     Costs one property lookup per call, which is nothing. */
  function docEl() {
    return document.documentElement;
  }

  var mounted = false;
  var started = false; // start() has run; the gate only opens once
  var modulesRun = {};
  var lastError = null; // reported by window.__igacne.state()

  function warn(e) {
    if (window.console && console.warn) console.warn('[' + P + ']', e);
  }

  function onTargetPage() {
    var path = String(window.location.pathname || '').replace(/\/+$/, '');
    for (var i = 0; i < CONFIG.onlyOnPaths.length; i++) {
      var want = CONFIG.onlyOnPaths[i].replace(/\/+$/, '');
      if (path === want) return true;
      if (want && path.length > want.length && path.slice(-want.length) === want) return true;
    }
    return false;
  }

  /* ── DOM helpers ──────────────────────────────────────────────────── */

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function svg(markup, cls) {
    var holder = el('span', cls);
    holder.innerHTML = markup;
    return holder;
  }

  /* Resolve a CONFIG.sections key to its rendered wrapper.
     Shopify does NOT render `#shopify-section-<id>` for template sections — it
     namespaces them per template, e.g.
       shopify-section-template--29761004142934__hero_fullwidth_split_YTkLFd
     The numeric part changes with the theme, so match the suffix rather than
     hardcoding it. Getting this wrong is silent: every lookup returns null and
     the whole test no-ops while the CSS still applies, which looks like "the
     styles half worked". */
  function section(key) {
    var id = CONFIG.sections[key];
    if (!id) return null;
    return (
      document.getElementById('shopify-section-' + id) ||
      document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]')
    );
  }

  /* Resolve the in-page reviews landing. Always `severeMulticolumn` — the
     rendered id carries a per-theme numeric prefix, so never hardcode it. */
  function reviewsTarget() {
    return section(CONFIG.reviewsJump.target);
  }

  function reviewsHref() {
    var node = reviewsTarget();
    return node && node.id ? '#' + node.id : '';
  }

  function captureHref(node) {
    var flag = 'data-' + P + '-hrefwas';
    if (node.getAttribute(flag) != null) return;
    var was = node.getAttribute('href');
    node.setAttribute(flag, was == null ? '' : was);
    var wasTarget = node.getAttribute('target');
    var wasRel = node.getAttribute('rel');
    if (wasTarget != null) node.setAttribute('data-' + P + '-targetwas', wasTarget);
    if (wasRel != null) node.setAttribute('data-' + P + '-relwas', wasRel);
    onFailsafe(function () {
      var orig = node.getAttribute(flag);
      if (orig) node.setAttribute('href', orig);
      else node.removeAttribute('href');
      node.removeAttribute(flag);
      var t = node.getAttribute('data-' + P + '-targetwas');
      if (t != null) { node.setAttribute('target', t); node.removeAttribute('data-' + P + '-targetwas'); }
      else node.removeAttribute('target');
      var r = node.getAttribute('data-' + P + '-relwas');
      if (r != null) { node.setAttribute('rel', r); node.removeAttribute('data-' + P + '-relwas'); }
      else node.removeAttribute('rel');
    });
  }

  /* Re-asserted every paint: the buy-box rating is an <a href="#looxReviews">
     and product-info can rewrite that href when the variant changes. */
  function pointAnchorAtReviews(node) {
    var href = reviewsHref();
    if (!node || !href) return;
    if (node.getAttribute('href') !== href) {
      captureHref(node);
      node.setAttribute('href', href);
    }
    if (node.getAttribute('target') === '_blank') {
      node.removeAttribute('target');
      node.removeAttribute('rel');
    }
  }

  function bindReviewsJump(node) {
    if (!node) return;
    if (node.tagName === 'A') {
      pointAnchorAtReviews(node);
      return;
    }
    once(node, 'revjump', function (el) {
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', CONFIG.reviewsJump.label);
      var go = function (e) {
        if (e) e.preventDefault();
        var target = reviewsTarget();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      var onKey = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go(e);
        }
      };
      el.addEventListener('click', go);
      el.addEventListener('keydown', onKey);
      onFailsafe(function () {
        el.removeEventListener('click', go);
        el.removeEventListener('keydown', onKey);
        el.removeAttribute('role');
        el.removeAttribute('tabindex');
      });
    });
  }

  /* Compare copy that came out of the admin against copy typed into CONFIG.
     Curly vs straight quotes, a stray non-breaking space and casing are all
     things a merchant edit changes without meaning to, and any of them would
     silently break a name match. */
  function normalise(value) {
    return String(value || '')
      .replace(/[‘’‛]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/[   ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* ── Copy rewrites ────────────────────────────────────────────────────
   * rewrite() is the one way this file changes theme copy. It does three things
   * that a bare `node.textContent = x` does not:
   *
   *   1. WRITES ONLY WHEN DIFFERENT, so it is safe to call from the paint loop.
   *      Assigning textContent replaces the text node and trips the
   *      MutationObserver, so an unconditional write is an endless repaint.
   *   2. RE-ASSERTS on every paint, which once() cannot. The selling-plan badges
   *      are rewritten by the theme itself from its own discount maths, so a
   *      one-shot rewrite is silently reverted the next time prices recompute
   *      and the control copy comes back with nobody watching.
   *   3. CAPTURES THE ORIGINAL the first time it touches a node and restores it
   *      on failsafe. This one matters more here than anywhere else in the file:
   *      failsafe is supposed to hand the visitor the CONTROL experience, and a
   *      test whose control still carries the variant's copy is not measuring
   *      what it thinks it is measuring.
   *
   * Handles text nodes as well as elements, because some of the copy this swaps
   * is the bare tail after a <strong> rather than a whole element.
   * ⚠️ Pre-existing gap, not fixed here: the beforeAfter module rewrites its
   * heading and CTA href with once() and no undo, so those two do survive a
   * failsafe.
   * -------------------------------------------------------------------- */
  var rewritten = [];
  var rewriteUndoArmed = false;

  function rewrite(node, want) {
    if (!node) return false;
    var isText = node.nodeType === 3;
    var current = isText ? node.nodeValue : node.textContent;
    if (current === want) return false;

    var seen = false;
    for (var i = 0; i < rewritten.length; i++) {
      if (rewritten[i].node === node) { seen = true; break; }
    }
    if (!seen) {
      // first touch wins: if the theme later writes its own copy back, the
      // captured value is still the real original rather than that
      rewritten.push({ node: node, text: current, isText: isText });
      if (!rewriteUndoArmed) {
        rewriteUndoArmed = true;
        onFailsafe(function () {
          for (var u = 0; u < rewritten.length; u++) {
            var entry = rewritten[u];
            if (entry.isText) entry.node.nodeValue = entry.text;
            else entry.node.textContent = entry.text;
          }
          rewritten = [];
        });
      }
    }

    if (isText) node.nodeValue = want;
    else node.textContent = want;
    return true;
  }

  // Run `fn` once per element, ever. The MutationObserver re-runs paint() a lot;
  // this is what stops modules from stacking duplicate DOM on every mutation.
  function once(node, tag, fn) {
    if (!node) return false;
    var flag = 'data-' + P + '-' + tag;
    if (node.hasAttribute(flag)) return false;
    node.setAttribute(flag, '');
    fn(node);
    return true;
  }

  /* ── Reorder ──────────────────────────────────────────────────────────
   * Sections are direct children of #MainContent, so ordering is a CSS job:
   * the stylesheet makes #MainContent a column flex container and we set
   * `order` per section. Nothing moves in the DOM, which means:
   *   - no layout jump — CSS applies before first paint, unlike a JS reorder
   *   - the theme's own scripts keep finding their nodes where they expect them
   *   - `shopify:section:load` in the editor cannot undo it
   *   - it reverses cleanly by dropping one class
   * Sticky children are the one caveat: `position: sticky` resolves against the
   * flex container, so if a section relies on sticky, verify it after ordering.
   * ------------------------------------------------------------------ */
  /* Resolve a key to a child of #MainContent: either a real Shopify section or
     one of the bands this test injects. */
  function orderable(key) {
    return section(key) || document.querySelector('[data-igacne-section="' + key + '"]');
  }

  function applyOrder() {
    if (!CONFIG.order.length && !CONFIG.moves.length) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    main.classList.add(P + '__main');

    /* Seed every child with its current position. Without this, flex gives any
       unnumbered sibling order:0 and it jumps to the top — which is why a
       partial reorder has to number everything, not just what moves. */
    var kids = main.children;
    for (var i = 0; i < kids.length; i++) {
      kids[i].style.order = String((i + 1) * 100);
    }

    // explicit full order wins when it is eventually filled in
    for (var j = 0; j < CONFIG.order.length; j++) {
      var ordered = orderable(CONFIG.order[j]);
      if (ordered) ordered.style.order = String((j + 1) * 100);
    }

    /* Then the targeted moves.
       ⚠️ The increment is +10 with a per-anchor counter, NOT a flat +50. Seeds
       are 100 apart, so a flat +50 works for ONE mover per anchor and breaks the
       moment two land on the same one or a chain forms: `B after A` then
       `C after B` gave C the same order as an untouched section, and flex breaks
       ties by DOM position, so C silently jumped above it. Counting per anchor
       leaves room for nine movers between any two seeds.
       Chains work because the anchor's order is read back live — so
       CONFIG.moves must list an anchor BEFORE anything that hangs off it. */
    var placed = {};
    for (var k = 0; k < CONFIG.moves.length; k++) {
      var rule = CONFIG.moves[k];
      var target = orderable(rule.move);
      var anchor = orderable(rule.after);
      if (!target || !anchor) continue;
      var base = parseInt(anchor.style.order, 10);
      placed[base] = (placed[base] || 0) + 1;
      target.style.order = String(base + placed[base] * 10);
    }
  }

  function applyHide() {
    for (var i = 0; i < CONFIG.hide.length; i++) {
      var node = section(CONFIG.hide[i]);
      if (node) node.classList.add(P + '--hidden');
    }
  }

  /* ── Modules ──────────────────────────────────────────────────────────
   * One entry per section of the scope. Each `run()` must be idempotent —
   * paint() calls them on every DOM mutation. Use once() for anything that
   * injects nodes. Returning early when the target is missing is normal: the
   * section may not have rendered yet.
   *
   *   { id: 'hero', label: 'Hero — swap text/image, stock notice', run: function () { … } }
   *
   * A module that throws is disabled for the rest of the session and logged;
   * the other modules and the control experience carry on.
   * ------------------------------------------------------------------ */
  /* Build a run of text nodes where some runs are SemiBold, without ever
     assigning a template string to innerHTML — the copy comes from CONFIG and
     stays text, so a stray `<` in a rewrite can never inject markup. */
  /* ⚠️ CAPTURE BEFORE CLEARING — the other half of the failsafe hole found on
     2026-08-20 (see the hero module's `stars` note). `runs()` empties the node
     and rebuilds its children, so without this the ORIGINAL markup is gone and
     failsafe() has nothing to put back: a degraded session kept the variant's
     hero description, benefit rows and pill copy while claiming to be control.

     Children are captured as NODES, not as text. The control description holds
     `<strong>over 500,000 people worldwide</strong>`, and restoring a flat
     string would silently drop that emphasis. `target.textContent = ''` detaches
     the children but the array still references them, so re-appending is exact.

     Same shape as rewrite(): first touch wins, one shared onFailsafe callback. */
  var rebuilt = [];
  var rebuildUndoArmed = false;

  function captureChildren(target) {
    for (var i = 0; i < rebuilt.length; i++) {
      if (rebuilt[i].node === target) return;      // already captured; keep the original
    }
    rebuilt.push({ node: target, kids: Array.prototype.slice.call(target.childNodes) });
    if (!rebuildUndoArmed) {
      rebuildUndoArmed = true;
      onFailsafe(function () {
        for (var u = 0; u < rebuilt.length; u++) {
          var entry = rebuilt[u];
          entry.node.textContent = '';
          for (var k = 0; k < entry.kids.length; k++) entry.node.appendChild(entry.kids[k]);
        }
        rebuilt = [];
      });
    }
  }

  function runs(target, parts, strongClass) {
    captureChildren(target);
    target.textContent = '';
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      var node = document.createTextNode(part.text);
      if (part.strong) {
        var strong = el('span', strongClass);
        strong.appendChild(node);
        target.appendChild(strong);
      } else {
        target.appendChild(node);
      }
    }
    return target;
  }

  /* Render `**bold**` runs without ever assigning a template string to
     innerHTML. The FAQ copy comes from `01 - IG FAQ PDP Accordions`, where it is
     written in this shorthand; keeping the shorthand means the two tests can be
     diffed against each other instead of drifting into two hand-marked copies.
     An unmatched `**` is left as literal text rather than swallowing the rest of
     the paragraph. */
  function emphasise(target, text) {
    var parts = String(text).split('**');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      // odd indices are the inside of a matched pair; a trailing odd run is not
      var strong = i % 2 === 1 && i < parts.length - 1;
      var node = document.createTextNode(parts[i]);
      if (strong) {
        var b = el('strong');
        b.appendChild(node);
        target.appendChild(b);
      } else {
        target.appendChild(node);
      }
    }
    return target;
  }

  /* One FAQ row: a <button> header and its panel. A button rather than a div so
     the accordion is keyboard reachable and announces its state for free —
     nothing in the frame shows focus, but the theme's own accordions are
     buttons and WCAG does not care what the frame draws. */
  function faqItem(spec) {
    var item = el('div', P + '__bb-faq-item');
    item.setAttribute('data-' + P + '-faq', spec.id);

    var head = el('button', P + '__bb-faq-head');
    head.type = 'button';
    head.setAttribute('aria-expanded', spec.open ? 'true' : 'false');

    var label = el('span', P + '__bb-faq-title');
    label.appendChild(document.createTextNode(spec.title));
    head.appendChild(label);

    var sign = el('span', P + '__bb-faq-sign');
    sign.setAttribute('aria-hidden', 'true');
    sign.appendChild(document.createTextNode(spec.open ? '−' : '+'));
    head.appendChild(sign);

    var panel = el('div', P + '__bb-faq-panel');
    if (!spec.open) panel.hidden = true;

    /* ⚠️ Round 3, ticket 4: the copy lives in an inner box and the frame's
       10/17.5 inset moved onto it. The panel itself must have NO padding —
       it is the box whose height is animated, and with `box-sizing: border-box`
       a padded box cannot go below its own padding, so `height: 0` would rest
       at 20px and the collapse would end in a visible step. */
    var body = el('div', P + '__bb-faq-body');

    for (var i = 0; i < spec.blocks.length; i++) {
      var block = spec.blocks[i];
      if (block.lines) {
        /* One <p> with <br> between, not a <ul>: the frame draws the ritual
           contents as a plain run of lines with no bullets and no indent. */
        var lines = el('p', P + '__bb-faq-p');
        for (var l = 0; l < block.lines.length; l++) {
          if (l) lines.appendChild(el('br'));
          emphasise(lines, block.lines[l]);
        }
        body.appendChild(lines);
      } else if (block.p) {
        body.appendChild(emphasise(el('p', P + '__bb-faq-p'), block.p));
      }
    }

    panel.appendChild(body);

    /* Animated open/close, matching the accordions the theme shipped on
       2026-08-25 (`assets/product-faq-accordions.js`, from test 01) — which is
       the "dropdowns on live" the ticket compares against. A block element
       cannot transition its own `hidden`, so the height is animated and
       `hidden` is set around it. Reopening mid-collapse resumes from the
       current height instead of snapping back to 0.
       Falls back to the instant toggle when the API is missing or the visitor
       asks for reduced motion — an A/B variant must never be the reason a
       motion-sensitive visitor gets motion. */
    var anim = null;

    function slide(open) {
      var reduced = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !panel.animate) {
        if (anim) { anim.cancel(); anim = null; }
        panel.hidden = !open;
        return;
      }

      /* ⚠️ MEASURE BEFORE cancel(), IN THIS ORDER. cancel() reverts the effect,
         so the box snaps straight back to its natural height — read it after
         and an interruption restarts from the full height instead of from
         where the eye left it, which is a visible jump up before the collapse.
         Same trap the theme's own accordion documents. */
      var from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      if (anim) { anim.cancel(); anim = null; }

      panel.hidden = false;
      panel.style.overflow = 'hidden';

      var to = open ? body.getBoundingClientRect().height : 0;

      anim = panel.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: 260, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
      );

      anim.onfinish = function () {
        anim = null;
        panel.style.overflow = '';
        if (!open) panel.hidden = true;
      };
    }

    head.addEventListener('click', function () {
      var open = head.getAttribute('aria-expanded') === 'true';
      head.setAttribute('aria-expanded', open ? 'false' : 'true');
      sign.textContent = open ? '+' : '−';
      slide(!open);
    });

    item.appendChild(head);
    item.appendChild(panel);
    return item;
  }

  /* One clinical-trial result card: donut, percentage over it, label under it.
     The percentage is a real text node centred over the SVG rather than baked
     into it, so it stays selectable, translatable and scalable with the type. */
  function trialCard(spec, ring) {
    var card = el('div', P + '__ct-card');

    var wrap = el('div', P + '__ct-donut');
    wrap.appendChild(svg(
      '<svg viewBox="0 0 140.401 140.401" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="' + ring + '" stroke="#0A75D0" stroke-width="17.5372"/>' +
      '<path d="' + spec.arc + '" stroke="#EDE7D9" stroke-opacity="0.6" stroke-width="17.5372" stroke-linecap="round"/>' +
      '</svg>',
      P + '__ct-ring'
    ));
    var value = el('span', P + '__ct-value');
    value.appendChild(document.createTextNode(spec.value));
    wrap.appendChild(value);
    card.appendChild(wrap);

    var label = el('p', P + '__ct-label');
    for (var i = 0; i < spec.lines.length; i++) {
      if (i) label.appendChild(el('br'));
      label.appendChild(document.createTextNode(spec.lines[i]));
    }
    card.appendChild(label);
    return card;
  }

  /* The review card (Figma 10198:4695). Flat enough not to need a builder per
     part; the only fiddly bit is the star row, which reuses the theme's star so
     it matches the rating line above the title exactly. */
  function reviewCard(cfg, icons) {
    var card = el('div', P + '__bb-review');
    card.setAttribute('data-' + P + '-built', '');

    var stars = el('div', P + '__bb-review-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', cfg.stars + ' out of 5 stars');
    for (var i = 0; i < cfg.stars; i++) {
      stars.appendChild(svg(icons.star, P + '__bb-review-star'));
    }
    card.appendChild(stars);

    var headline = el('p', P + '__bb-review-headline');
    headline.appendChild(document.createTextNode(cfg.headline));
    card.appendChild(headline);

    var quote = el('p', P + '__bb-review-quote');
    quote.appendChild(document.createTextNode(cfg.quote));
    card.appendChild(quote);

    var footer = el('div', P + '__bb-review-footer');
    var avatar = el('div', P + '__bb-review-avatar');
    avatar.setAttribute('aria-hidden', 'true');
    avatar.appendChild(document.createTextNode(cfg.initials));
    footer.appendChild(avatar);

    var who = el('div', P + '__bb-review-who');
    var name = el('p', P + '__bb-review-name');
    name.appendChild(document.createTextNode(cfg.name));
    who.appendChild(name);

    var verified = el('p', P + '__bb-review-verified');
    verified.appendChild(svg(icons.check, P + '__bb-review-check'));
    verified.appendChild(document.createTextNode(cfg.verified));
    who.appendChild(verified);

    footer.appendChild(who);
    card.appendChild(footer);
    return card;
  }

  /* ── Trustpilot loader ────────────────────────────────────────────────
   * The bootstrap only auto-scans the DOM once, on its own load. Widgets added
   * afterwards — ours are — stay blank unless `Trustpilot.loadFromElement` is
   * called on them, so the script is loaded once and every band is initialised
   * either immediately or as soon as it is ready.
   * ------------------------------------------------------------------ */
  var tpState = 'idle'; // idle | loading | ready
  var tpPending = [];

  function tpInit(root) {
    var widgets = root.querySelectorAll('.trustpilot-widget');
    for (var i = 0; i < widgets.length; i++) {
      try {
        window.Trustpilot.loadFromElement(widgets[i], true);
      } catch (err) {
        warn('Trustpilot widget failed to initialise: ' + err);
      }
    }
  }

  function tpFlush() {
    tpState = 'ready';
    for (var i = 0; i < tpPending.length; i++) tpInit(tpPending[i]);
    tpPending.length = 0;
  }

  /* The band is never removed. An earlier version deleted it when the library
     had not appeared within 10s, which is exactly what made it flash on screen
     and vanish once the page settled: this store runs a Consentmo consent
     blocker, so `window.Trustpilot` can arrive late or only after the visitor
     accepts. Until it does, the band shows Trustpilot's own required fallback
     link, and the poll keeps running. */
  function tpGiveUp(reason) {
    tpState = 'idle';
    tpPending.length = 0;
    warn(reason);
  }

  // Poll for the library when someone else owns the script tag.
  function tpWait(tries) {
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      tpFlush();
      return;
    }
    if (tries > 600) { // 5 minutes, enough for a consent prompt to be answered
      tpGiveUp('Trustpilot never initialised; the band stays with its fallback link');
      return;
    }
    window.setTimeout(function () { tpWait(tries + 1); }, 500);
  }

  function tpLoad(root) {
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      tpInit(root);
      return;
    }
    tpPending.push(root);
    if (tpState !== 'idle') return;
    tpState = 'loading';

    /* layout/theme.liquid already ships the bootstrap (async, in <head>).
       Injecting a second copy is a known way to leave widgets un-initialised,
       so when the tag is already on the page we wait for the library instead of
       loading it again. */
    if (document.querySelector('script[src*="tp.widget.bootstrap"]')) {
      tpWait(0);
      return;
    }

    var script = document.createElement('script');
    script.src = CONFIG.trustpilot.bootstrap;
    script.async = true;
    script.onload = tpFlush;
    script.onerror = function () {
      tpGiveUp('Trustpilot bootstrap failed to load; the band stays with its fallback link');
    };
    document.head.appendChild(script);
  }

  /* Static composition. Text is real text in Mori so it stays selectable and
     translatable; only the star strip and the wordmark are images, because they
     are Trustpilot artwork. */
  function tpStatic() {
    var s = CONFIG.trustpilot.staticContent;

    /* In-page reviews jump, not the Trustpilot profile. Ticket 1 made this a
       dead <div> so it would not leave the LP; it is an <a> again, but the
       href is CONFIG.reviewsJump (Severe Acne carousel), set here when the
       section is already in the DOM and re-asserted by the reviewsJump module. */
    var frag = el('a', P + '__tp-link');
    var jump = reviewsHref();
    if (jump) frag.setAttribute('href', jump);
    frag.setAttribute('aria-label', CONFIG.reviewsJump.label);

    var score = el('p', P + '__tp-text ' + P + '__tp-only-desktop');
    score.appendChild(document.createTextNode(s.scoreLabel));
    var strong = el('span', P + '__strong');
    strong.appendChild(document.createTextNode(s.score));
    score.appendChild(strong);
    frag.appendChild(score);

    /* ⚠️ The green Trustpilot star image, restored on request after a round with
       an SVG row. Keep it an image: these are Trustpilot's own green tiles, and
       ticket 12 turned out to be about the HERO stars, not this band.
       The export is a wider crop than the 124.768x25.315 slot — there is a grey
       circle past the fifth star — so the CSS reproduces Figma's own 119.57%
       scale and clips it rather than stretching the file. */
    var stars = el('span', P + '__tp-stars ' + P + '__tp-only-desktop');
    var starsImg = el('img');
    starsImg.src = s.stars;
    starsImg.alt = s.starsAlt;
    stars.appendChild(starsImg);
    frag.appendChild(stars);

    var count = el('p', P + '__tp-text ' + P + '__tp-only-desktop');
    var lead = el('span', P + '__strong');
    lead.appendChild(document.createTextNode(s.countLead));
    count.appendChild(lead);
    count.appendChild(document.createTextNode(s.countRest));
    frag.appendChild(count);

    var logo = el('span', P + '__tp-logo ' + P + '__tp-only-desktop');
    var logoImg = el('img');
    logoImg.src = s.logo;
    logoImg.alt = s.logoAlt;
    logo.appendChild(logoImg);
    frag.appendChild(logo);

    /* ── Mobile: the Trustpilot Mini widget, rebuilt from DOM ──
       Frame 10198:5872 is a 320x163 SCREENSHOT of the widget, so there was no
       markup to copy — the geometry below was measured off the raster's own
       pixels rather than guessed:

         content left edge   39     (inside the 320 box)
         wordmark            136 x 34   at y 25
         star strip          233 x 43   at y 66     -> 8 under the wordmark
         figures line        ~14px cap  at y 121    -> 13 under the strip

       Built rather than kept as an image so ticket 1's numbers reach this
       breakpoint: the raster has "3,796 reviews" baked into its pixels, which
       contradicted the 4,004 on desktop. Same layout, our figures.

       The strip shows 4.5 stars — grey counted 9.7% of the coloured pixels,
       i.e. half of one tile in five. See the CSS for how that half is drawn. */
    var mob = el('span', P + '__tp-mobile ' + P + '__tp-only-mobile');

    var mobLogo = el('span', P + '__tp-mobile-logo');
    var mobLogoImg = el('img');
    mobLogoImg.src = s.logo;
    mobLogoImg.alt = s.logoAlt;
    mobLogo.appendChild(mobLogoImg);
    mob.appendChild(mobLogo);

    /* Two layers of the SAME green export: a greyscaled copy underneath for the
       unearned part, and the green one on top clipped to score/5. That keeps the
       white star shape inside the grey half, which a flat grey block would lose,
       and it needs no second asset. */
    var mobStars = el('span', P + '__tp-mobile-stars');
    mobStars.setAttribute('role', 'img');
    mobStars.setAttribute('aria-label', s.starsAlt);

    var strip = function (cls) {
      var wrap = el('span', cls);
      var img = el('img');
      img.src = s.stars;
      img.alt = '';
      wrap.appendChild(img);
      return wrap;
    };

    mobStars.appendChild(strip(P + '__tp-mobile-stars-base'));
    var mobFill = strip(P + '__tp-mobile-stars-fill');
    mobFill.style.width = Math.max(0, Math.min(100, (parseFloat(s.score) || 0) / 5 * 100)) + '%';
    mobStars.appendChild(mobFill);
    mob.appendChild(mobStars);

    /* "TrustScore 4.7 | 4,004 reviews" — the frame's own wording, underlining the
       count the way the widget does. The numbers are CONFIG's, not the raster's. */
    var mobText = el('p', P + '__tp-mobile-text');
    mobText.appendChild(document.createTextNode(s.mobileScoreLabel));
    var mobScore = el('span', P + '__strong');
    mobScore.appendChild(document.createTextNode(s.score));
    mobText.appendChild(mobScore);
    mobText.appendChild(document.createTextNode(s.mobileSeparator));
    var mobCount = el('span', P + '__tp-mobile-count');
    mobCount.appendChild(document.createTextNode(s.countLead + s.mobileCountRest));
    mobText.appendChild(mobCount);
    mob.appendChild(mobText);

    frag.appendChild(mob);

    return frag;
  }

  function tpWidget(kind) {
    var spec = CONFIG.trustpilot[kind];
    var box = el('div', 'trustpilot-widget ' + P + '__tp-widget ' + P + '__tp-widget--' + kind);
    box.setAttribute('data-locale', CONFIG.trustpilot.locale);
    box.setAttribute('data-template-id', spec.templateId);
    box.setAttribute('data-businessunit-id', CONFIG.trustpilot.businessunitId);
    box.setAttribute('data-style-height', spec.height);
    box.setAttribute('data-style-width', spec.width);
    box.setAttribute('data-token', spec.token);

    // Fallback until the iframe takes over. Same in-page reviews jump as the
    // static band — not the Trustpilot profile, which would bounce this LP.
    var link = el('a');
    var jump = reviewsHref();
    if (jump) {
      link.href = jump;
    } else {
      link.href = CONFIG.trustpilot.reviewUrl;
      link.target = '_blank';
      link.rel = 'noopener';
    }
    link.textContent = 'Trustpilot';
    box.appendChild(link);
    return box;
  }

  /* DM Sans is not one of the theme's faces — base.css registers Mori, Migra,
     Apercu, Apercu Mono Pro, Inter and Mulish — so the routine band has to bring
     its own. Same source as `01 - IG FAQ PDP Accordions`, plus the 400 weight
     that this design also uses. */
  function loadDmSans() {
    if (document.querySelector('link[data-' + P + '-font]')) return;
    var pre = el('link');
    pre.rel = 'preconnect';
    pre.href = 'https://fonts.gstatic.com';
    pre.crossOrigin = 'anonymous';
    document.head.appendChild(pre);
    var sheet = el('link');
    sheet.rel = 'stylesheet';
    sheet.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,700&display=swap';
    sheet.setAttribute('data-' + P + '-font', '');
    document.head.appendChild(sheet);
  }

  /* One product column. The DOM is flat — name, media, badge, copy — because the
     two frames stack it differently: desktop is a centred column, mobile is a
     two-column step card with the jar spanning all three text rows. A flat list
     lets CSS grid place it both ways without a wrapper that only one of them
     wants. */
  function kitItem(spec) {
    var cfg = CONFIG.kitRoutine;
    var item = el('article', P + '__kit-item');

    var name = el('h3', P + '__kit-name');
    name.appendChild(document.createTextNode(spec.name));
    item.appendChild(name);

    /* The box is the Figma node; the asset is larger because its shadow is baked
       in, so the <img> is sized and offset to hang outside it. See the note on
       CONFIG.kitRoutine for where these come from. */
    var media = el('div', P + '__kit-media');
    media.style.setProperty('--' + P + '-bleed-l', spec.bleed.l + '%');
    media.style.setProperty('--' + P + '-bleed-t', spec.bleed.t + '%');
    media.style.setProperty('--' + P + '-bleed-w', (100 + spec.bleed.l + spec.bleed.r) + '%');
    media.style.setProperty('--' + P + '-bleed-h', (100 + spec.bleed.t + spec.bleed.b) + '%');

    var img = el('img', P + '__kit-img');
    img.src = spec.image;
    img.alt = spec.name;
    img.loading = 'lazy';
    media.appendChild(img);
    item.appendChild(media);

    var badge = el('p', P + '__kit-badge');
    badge.appendChild(svg(cfg.icons[spec.icon], P + '__kit-badge-icon'));
    var label = el('span', P + '__kit-badge-text');
    label.appendChild(document.createTextNode(spec.badge));
    badge.appendChild(label);
    item.appendChild(badge);

    var copy = el('p', P + '__kit-copy');
    copy.appendChild(document.createTextNode(spec.text));
    item.appendChild(copy);

    return item;
  }

  /* Copy that the mobile frame shortens because the 122px column cannot hold
     the desktop string. Both forms are rendered and CSS shows one per
     breakpoint; swapping the text on resize instead would mean a resize
     listener and a reflow for what is a presentational choice. `short` is
     optional — without it the one string is used at both breakpoints. */
  function cmpText(target, long, short) {
    if (!short) {
      target.appendChild(document.createTextNode(long));
      return target;
    }
    var a = el('span', P + '__cmp-long');
    a.appendChild(document.createTextNode(long));
    target.appendChild(a);
    var b = el('span', P + '__cmp-short');
    b.appendChild(document.createTextNode(short));
    target.appendChild(b);
    return target;
  }

  /* Point a theme <img> at one of our assets.
     ⚠️ `srcset` and `sizes` have to go, not just `src` — the browser picks from
     srcset when it is present, so swapping src alone changes nothing visible.
     That trap has already cost this file one round trip on the hero.
     width/height go with them: they are the theme's old intrinsic ratio, and
     leaving them reserves the wrong box and shifts the layout as the new image
     decodes. Every attribute touched is captured for the failsafe. */
  function swapImage(node, spec, alt) {
    var attrs = ['src', 'srcset', 'sizes', 'width', 'height', 'alt'];
    var was = {};
    for (var i = 0; i < attrs.length; i++) was[attrs[i]] = node.getAttribute(attrs[i]);

    onFailsafe(function () {
      for (var j = 0; j < attrs.length; j++) {
        if (was[attrs[j]] === null) node.removeAttribute(attrs[j]);
        else node.setAttribute(attrs[j], was[attrs[j]]);
      }
    });

    node.removeAttribute('srcset');
    node.removeAttribute('sizes');
    node.setAttribute('src', spec.src);
    node.setAttribute('width', String(spec.width));
    node.setAttribute('height', String(spec.height));
    if (alt) node.setAttribute('alt', alt);
  }

  /* Replace a rich-text block's paragraphs with ours.
     The original child NODES are kept, not their markup, so the failsafe puts
     back exactly what the theme rendered — including any <strong> runs — rather
     than a re-parsed approximation. Nothing is ever assigned to innerHTML: the
     copy comes from CONFIG and stays text, so a stray `<` cannot inject markup. */
  function replaceParagraphs(node, paragraphs) {
    var original = [];
    while (node.firstChild) original.push(node.removeChild(node.firstChild));

    onFailsafe(function () {
      while (node.firstChild) node.removeChild(node.firstChild);
      for (var r = 0; r < original.length; r++) node.appendChild(original[r]);
    });

    for (var i = 0; i < paragraphs.length; i++) {
      var p = el('p');
      p.appendChild(document.createTextNode(paragraphs[i]));
      node.appendChild(p);
    }
    return node;
  }

  /* The theme's CTA button, built from its own classes so it inherits base.css
     (#e16203, white, the flex centring) instead of restating it. */
  function ctaButton(label, href, cls) {
    var wrap = el('div', 'cta-button-wrapper ' + cls);
    wrap.setAttribute('data-' + P + '-built', '');

    var link = el('a', 'cta-button');
    link.setAttribute('href', href);

    var inner = el('div', 'cta-button__inner');
    var text = el('span', 'cta-button__text');
    text.appendChild(document.createTextNode(label));
    inner.appendChild(text);
    link.appendChild(inner);
    wrap.appendChild(link);
    return wrap;
  }

  /* One column header: the product shot over its caption. */
  function headCell(spec, kind) {
    var cell = el('div', P + '__cmp-cell ' + P + '__cmp-cell--' + kind + ' ' + P + '__cmp-head');

    var media = el('div', P + '__cmp-head-media');
    var img = el('img', P + '__cmp-head-img');
    img.setAttribute('src', spec.image);
    img.setAttribute('alt', spec.alt);
    img.setAttribute('loading', 'lazy');
    media.appendChild(img);
    cell.appendChild(media);

    cell.appendChild(cmpText(el('p', P + '__cmp-head-label'), spec.label, spec.labelShort));
    return cell;
  }

  /* One body cell: the tick/cross chip and its line of copy. */
  function bodyCell(text, short, kind, icon) {
    var cell = el('div', P + '__cmp-cell ' + P + '__cmp-cell--' + kind);
    cell.appendChild(svg(icon, P + '__cmp-chip'));
    cell.appendChild(cmpText(el('p', P + '__cmp-text'), text, short));
    return cell;
  }

  var MODULES = [
    {
      id: 'hero',
      label: 'Hero — copy rewrite, stock pill, column swap',
      run: function () {
        var root = section('hero');
        if (!root) return;

        var cfg = CONFIG.hero;

        /* Copy. Each rewrite is guarded separately so a markup change in one
           block cannot stop the others from applying. */
        /* ⚠️ A THIRD HOLE IN failsafe(), found by qa/round2-probe.js on
           2026-08-20 and fixed here. This line used to assign `node.textContent`
           directly, which is exactly what the "rewrite() is the only way this
           file changes theme copy" rule exists to prevent: nothing captured the
           original, so failsafe() left the variant's figure on the page and a
           degraded session showed a hero that was neither arm. Pre-existing —
           round 2 ticket 9 only changed the string being written, which is what
           made the probe look at it.
           The same trap as the two holes fixed on 2026-08-13. If you add another
           copy swap, go through rewrite() or capture-and-restore it yourself the
           way the star `d` attribute below does. */
        var stars = root.querySelector('.hero-fullwidth-split__reviews-text, .hero-fullwidth-split__reviews span:not(.hero-fullwidth-split__star)');
        if (stars) once(stars, 'stars', function (node) { rewrite(node, cfg.starsText); });

        /* Sharpen the star shape — ticket 12. The `d` is an attribute, not text,
           so rewrite() cannot carry it; the old value is captured per node and
           restored on failsafe the same way. */
        var starSvgs = root.querySelectorAll('.hero-fullwidth-split__star');
        for (var st = 0; st < starSvgs.length; st++) {
          var starPath = starSvgs[st].querySelector('path');
          if (!starPath || starPath.getAttribute('d') === cfg.starPath) continue;
          (function (node, was) {
            once(node, 'starshape', function () {
              onFailsafe(function () { node.setAttribute('d', was); });
            });
          })(starPath, starPath.getAttribute('d'));
          starPath.setAttribute('d', cfg.starPath);
        }

        var descs = root.querySelectorAll('.hero-fullwidth-split__description-desktop, .hero-fullwidth-split__description-mobile');
        for (var d = 0; d < descs.length; d++) {
          once(descs[d], 'desc', function (node) { runs(node, cfg.description, P + '__strong'); });
        }

        var cta = root.querySelector('.hero-fullwidth-split__cta');
        if (cta) {
          once(cta, 'cta', function (node) {
            // the label can be nested in an <a>/<span>; write to the deepest
            // element that holds the text so the button's own styling survives
            var label = node.querySelector('a, button') || node;
            // through rewrite() so failsafe() restores the control label
            rewrite(label, cfg.ctaText);
          });
        }

        var items = root.querySelectorAll('.hero-fullwidth-split__check-item:not([data-hfs-high-demand])');
        for (var b = 0; b < items.length && b < cfg.benefits.length; b++) {
          (function (item, spec) {
            var text = item.querySelector('.hero-fullwidth-split__check-text');
            if (text) once(text, 'benefit', function (node) {
              runs(node, [{ text: spec.lead, strong: true }, { text: spec.rest }], P + '__strong');
            });
            var icon = item.querySelector('.hero-fullwidth-split__check-icon');
            if (icon) once(icon, 'icon', function (node) {
              node.innerHTML = cfg.checkIcon;
            });
          })(items[b], cfg.benefits[b]);
        }

        /* The pill. The section already renders this slot itself — the first
           child of the checklist, marked [data-hfs-high-demand] — driven by a
           section setting that is already on. So restyle what is there rather
           than injecting a second one; only build from scratch if the setting
           is ever switched off. */
        var checklist = root.querySelector('.hero-fullwidth-split__checklist');
        if (checklist) {
          once(checklist, 'pill', function (list) {
            var pill = list.querySelector('[data-hfs-high-demand]');
            if (!pill) {
              pill = el('div');
              pill.setAttribute('data-hfs-high-demand', '');
              var span = el('span', 'hero-fullwidth-split__check-text');
              span.textContent = cfg.pillText;
              pill.appendChild(span);
              list.insertBefore(pill, list.firstChild);
            }
            pill.classList.add(P + '__pill');
            var text = pill.querySelector('.hero-fullwidth-split__check-text');
            if (text) {
              text.classList.add(P + '__pill-text');
              // rewrite(), not textContent — the pill slot is the THEME's node
              // when the setting is on, so its copy has to survive a failsafe
              rewrite(text, cfg.pillText);
            }
            if (!pill.querySelector('.' + P + '__pill-icon')) {
              pill.insertBefore(svg(cfg.pillIcon, P + '__pill-icon'), pill.firstChild);
            }
          });
        }

        /* Photo. Skipped entirely while the export is missing, so the rest of
           the hero still ships with the current image rather than a blank box.
           The theme renders a responsive `srcset`, which would keep winning over
           a plain `src` swap — both have to go. */
        if (cfg.image.desktop) {
          var img = root.querySelector('.hero-fullwidth-split__image-container img');
          if (img) {
            once(img, 'photo', function (node) {
              node.removeAttribute('srcset');
              node.removeAttribute('sizes');
              node.removeAttribute('width');
              node.removeAttribute('height');
              node.src = cfg.image.desktop;
              if (cfg.image.alt) node.alt = cfg.image.alt;
            });
          }
        }
      }
    },

    {
      id: 'trustpilot',
      label: 'Trustpilot — new band under the hero',
      run: function () {
        var hero = section('hero');
        if (!hero || !hero.parentNode) return;

        /* Guard on the band's own presence rather than a marker on the hero.
           If anything re-renders this part of the page — the theme, an app, or
           Intelligems itself — the band simply gets rebuilt on the next paint
           instead of staying gone. */
        if (document.querySelector('.' + P + '__tp')) return;

        var band = el('section', P + '__tp');
        /* tagged so the reorder can address it like a real section once
           CONFIG.order is filled in — it is not a Shopify section, so
           section() will never find it */
        band.setAttribute('data-igacne-section', 'trustpilot');
        // ours, not the theme's — failsafe() takes it back out, same as the kit
        // band. Without this it survived as an unstyled band; found by qa/live-probe.js.
        band.setAttribute('data-' + P + '-built', '');

        if (CONFIG.trustpilot.mode === 'static') {
          band.className += ' ' + P + '__tp--static';
          band.appendChild(tpStatic());
          hero.parentNode.insertBefore(band, hero.nextSibling);
          return;
        }

        band.appendChild(tpWidget('desktop'));
        band.appendChild(tpWidget('mobile'));
        hero.parentNode.insertBefore(band, hero.nextSibling);
        tpLoad(band);
      }
    },

    {
      id: 'press',
      label: 'Press quotes — restyle, mobile dots, proof heading, moved under Trustpilot',
      run: function () {
        var root = section('press');
        if (!root) return;

        /* Control heading is "Trusted by 800,000+ People Worldwide". Re-assert
           every paint (no once()) so a section re-render cannot bring 800,000
           back. rewrite() no-ops when the text already matches. Independent of
           the slider work below — the heading has to swap even if dots fail. */
        var heading = root.querySelector('.press-mention__heading-text');
        if (heading) rewrite(heading, CONFIG.hero.starsText);

        var slider = root.querySelector('.press-mention__carousel');
        var controls = root.querySelector('.press-mention__controls');
        if (!slider || !controls) return;

        /* The published theme renders arrows here, not dots — the dots markup
           exists in the repo's press-mention.liquid but not in the live theme,
           so they have to be built. */
        if (!controls.querySelector('.' + P + '__dots')) {
          var slides = slider.querySelectorAll('.press-mention__item');
          if (!slides.length) return;

          var dots = el('div', P + '__dots');
          dots.setAttribute('role', 'tablist');

          var makeDot = function (index) {
            var dot = el('button', P + '__dot' + (index === 0 ? ' is-active' : ''));
            dot.type = 'button';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('data-index', String(index));
            dot.setAttribute('aria-label', 'Slide ' + (index + 1) + ' of ' + slides.length);
            dot.addEventListener('click', function () {
              var slide = slider.querySelectorAll('.press-mention__item')[index];
              if (slide) slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
            });
            return dot;
          };

          for (var i = 0; i < slides.length; i++) dots.appendChild(makeDot(i));
          controls.appendChild(dots);

          /* Track the slider itself rather than our own clicks, so swipes and
             the section's auto-rotate keep the active dot honest. */
          var sync = function () {
            /* Nearest slide to the current scroll position. An earlier
               "last one past the midpoint" test picked the middle item when the
               track is wider than the viewport, which is exactly the desktop
               case. */
            var items = slider.querySelectorAll('.press-mention__item');
            var active = 0;
            var best = Infinity;
            for (var n = 0; n < items.length; n++) {
              var dist = Math.abs(items[n].offsetLeft - slider.scrollLeft);
              if (dist < best) { best = dist; active = n; }
            }

            /* ⚠️ Ticket 7: at the END of the track the nearest-slide test can
               never reach the last item. Scrolling clamps at
               scrollWidth - clientWidth, which on mobile stops short of the last
               slide's own offsetLeft — so dragging all the way right still lit
               the second-to-last dot and it read as "one dot left to see".
               Once the track is at its maximum, the last slide IS the one in
               view, whatever the arithmetic says. */
            var maxScroll = slider.scrollWidth - slider.clientWidth;
            if (maxScroll > 0 && slider.scrollLeft >= maxScroll - 1) active = items.length - 1;
            var all = dots.children;
            for (var m = 0; m < all.length; m++) {
              var on = m === active;
              all[m].classList.toggle('is-active', on);
              if (on) { all[m].setAttribute('aria-current', 'true'); }
              else { all[m].removeAttribute('aria-current'); }
            }
          };
          var ticking = false;
          slider.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () { ticking = false; sync(); });
          }, { passive: true });
          sync();
        }
      }
    },

    {
      id: 'beforeAfter',
      label: 'Before & After — new heading, repoint the severe-case CTA',
      run: function () {
        var root = section('beforeAfter');
        if (!root) return;

        var cfg = CONFIG.beforeAfter;

        /* Both headings are in the markup; the theme reveals one per breakpoint
           with .desktop-only / .mobile-only, so both have to be rewritten. */
        var desktop = root.querySelector('.multicolumn__title .title .desktop-only');
        if (desktop) once(desktop, 'title', function (node) {
          node.textContent = '';
          for (var i = 0; i < cfg.titleDesktop.length; i++) {
            if (i) node.appendChild(el('br'));
            node.appendChild(document.createTextNode(cfg.titleDesktop[i]));
          }
        });

        var mobile = root.querySelector('.multicolumn__title .title .mobile-only');
        if (mobile) once(mobile, 'title', function (node) {
          node.textContent = cfg.titleMobile;
        });

        /* Revealing the CTA is the stylesheet's job — it only has to beat the
           `hidden` class the theme hardcodes. This fixes where it goes.
           Resolved through section() rather than written as a literal: the
           rendered id carries a per-theme numeric prefix, so the href stored in
           the section settings would rot on the next theme copy anyway. */
        var link = root.querySelector('.multicolumn__bottom-text a[href^="#"]');
        var target = section(cfg.ctaTarget);
        if (link && target && target.id) {
          once(link, 'cta', function (node) {
            node.setAttribute('href', '#' + target.id);
            node.setAttribute('title', '#' + target.id);
          });
        }
      }
    },

    {
      id: 'severe',
      label: 'Severe Acne Fixed in Weeks — break the mobile heading per the frame',
      run: function () {
        var root = section('severeMulticolumn');
        if (!root) return;

        /* Revealing the section, moving it below the buy box and hiding the flat
           duplicate are all declarative — the CSS reveal, CONFIG.moves and
           CONFIG.hide. This module only has the line break to do.

           The theme renders both headings and shows one per breakpoint, so this
           touches .mobile-only alone; the desktop frame is a single line and the
           control already renders it that way. */
        var mobile = root.querySelector('.multicolumn__title .title .mobile-only');
        if (!mobile) return;

        var head = CONFIG.severe.titleMobileBreakAfter;
        var first = mobile.firstChild;
        if (!first || first.nodeType !== 3) return;
        if (normalise(first.nodeValue).indexOf(normalise(head)) !== 0) return;

        once(mobile, 'title', function (node) {
          /* The space is deliberately LEFT on the tail rather than trimmed. With
             the break in place CSS drops it — whitespace at the start of a line
             is removed in layout — and when failsafe() takes the <br> back out,
             the two text nodes rejoin as the original run instead of colliding
             into "Severe AcneFixed".
             Marking the <br> `-built` is the whole reversal: failsafe() already
             removes every node carrying that attribute. */
          var rest = document.createTextNode(first.nodeValue.slice(head.length));
          first.nodeValue = head;
          node.insertBefore(rest, first.nextSibling);
          var br = el('br');
          br.setAttribute('data-' + P + '-built', '');
          node.insertBefore(br, rest);
        });
      }
    },

    {
      id: 'buyBox',
      label: 'Buy box — review card, FAQ, copy swaps, title/stars order',
      run: function () {
        var root = section('buyBox');
        if (!root) return;

        var cfg = CONFIG.buyBox;

        /* 1. Title above the stars line.
           Done by moving the node, NOT with `order`: .product__info-container is
           `display: block` and also the sticky column, so turning it into a flex
           container to reorder two children would change margin collapsing and
           how sticky resolves for the whole right-hand side. Two adjacent
           siblings are cheaper to move than that is to risk.
           Only desktop needs it — the mobile block (.product__mobile-title-rating)
           already renders title first, which is what the mobile frame draws. */
        var info = root.querySelector('.product__info-container');
        if (info) {
          var rating = null;
          var title = null;
          for (var c = 0; c < info.children.length; c++) {
            var kid = info.children[c];
            if (!rating && kid.classList.contains('rating-wrapper')) rating = kid;
            if (!title && kid.classList.contains('product__title')) title = kid;
          }
          if (rating && title) {
            once(info, 'order', function () {
              // only act if the stars actually come first
              if (!(title.compareDocumentPosition(rating) & Node.DOCUMENT_POSITION_PRECEDING)) return;
              info.insertBefore(title, rating);
              onFailsafe(function () {
                if (title.parentNode === info && rating.parentNode === info) info.insertBefore(rating, title);
              });
            });
          }
        }

        /* 2. The stars line. Loox's live count stays; the tail is the same
           proof line as the hero. Loox re-renders this node, so re-derive the
           count from whatever is there now rather than remembering it. */
        var starTexts = root.querySelectorAll('.stars-rating__text');
        var proof = CONFIG.hero.starsText;
        for (var s = 0; s < starTexts.length; s++) {
          var raw = starTexts[s].textContent || '';
          var close = raw.indexOf(')');
          if (raw.indexOf(proof) === -1) {
            var head = close > -1 ? raw.slice(0, close + 1).trim() : '';
            rewrite(starTexts[s], (head ? head + ' ' : '') + proof);
          }
        }

        /* 3. Benefits row under the CTA — two of the three labels differ. */
        var rowTexts = root.querySelectorAll('.rv-benefit__text');
        for (var r = 0; r < rowTexts.length; r++) {
          for (var rb = 0; rb < cfg.benefitRow.length; rb++) {
            var swap = cfg.benefitRow[rb];
            if (normalise(rowTexts[r].textContent) !== normalise(swap.from)) continue;
            rewrite(rowTexts[r], swap.to);
            break;
          }
        }

        /* 4. The subscription card's six benefits and its badge. The theme
           already renders the frame's layout — two columns, red ✗, strikethrough
           — so this is words only. Matched on the current <strong> so a merchant
           edit skips the row instead of writing the wrong words into it. */
        var planBenefits = root.querySelectorAll('.selling-plans-alt__benefit');
        for (var b = 0; b < planBenefits.length; b++) {
          var strong = planBenefits[b].querySelector('strong');
          if (!strong) continue;
          for (var pb = 0; pb < cfg.planBenefits.length; pb++) {
            var spec = cfg.planBenefits[pb];
            var isFrom = normalise(strong.textContent) === normalise(spec.from);
            // once rewritten, the row matches `strong`, not `from` — recognise
            // both so a re-paint finds its own work instead of falling through
            if (!isFrom && normalise(strong.textContent) !== normalise(spec.strong)) continue;
            /* The tail is the bare text node after the <strong>. Rewriting the
               two in place, rather than clearing and re-appending, is what lets
               both be captured for the failsafe restore. */
            var tail = strong.nextSibling;
            rewrite(strong, spec.strong);
            if (tail && tail.nodeType === 3) rewrite(tail, spec.tail);
            break;
          }
        }

        var subBadge = root.querySelector('[data-selling-plan-badge="subscription"]');
        if (subBadge) {
          var pct = String(subBadge.textContent).match(/(\d+)\s*%/);
          if (pct) rewrite(subBadge, 'SAVE ' + pct[1] + '% ' + cfg.subscriptionBadgeTail);
        }

        /* 5. Default purchase option. A no-op unless CONFIG asks for the other
           one — see the note on `defaultPlan`. Driven by clicking the radio the
           theme owns rather than by setting the hidden input, so the theme's own
           script recomputes the price, the badge and the CTA label. */
        if (cfg.defaultPlan === 'subscription') {
          var subInput = root.querySelector('.selling-plans-alt__option--subscription .selling-plans-alt__radio-input');
          if (subInput && !subInput.checked) once(subInput, 'default', function (node) { node.click(); });
        }

        /* 6. The review card, between the gallery thumbnails and the
           "INSTANT ACNE & REDNESS TREATMENT" block. Guarded on the card's own
           presence rather than a marker on the anchor: product-info re-renders
           this column on variant change, and a marker would leave it gone. */
        var imageText = root.querySelector('.rv-image-text');
        if (imageText && imageText.parentNode && !root.querySelector('.' + P + '__bb-review')) {
          imageText.parentNode.insertBefore(reviewCard(cfg.review, cfg.icons), imageText);
        }

        /* 7. The FAQ, after the benefits row — "below USPs", as the frame's own
           annotation puts it. Same presence guard. */
        var benefitsRow = root.querySelector('.rv-benefits-row');
        if (benefitsRow && benefitsRow.parentNode && !root.querySelector('.' + P + '__bb-faq')) {
          var faq = el('div', P + '__bb-faq');
          faq.setAttribute('data-' + P + '-built', '');
          for (var f = 0; f < cfg.faq.length; f++) faq.appendChild(faqItem(cfg.faq[f]));
          benefitsRow.parentNode.insertBefore(faq, benefitsRow.nextSibling);
        }
      }
    },

    {
      id: 'clinicalTrial',
      label: 'Clinical trial — condense to the panel, build the four donuts',
      run: function () {
        var root = section('clinicalTrial');
        if (!root) return;

        var container = root.querySelector('.iws-blocks-container');
        if (!container) return;

        var cfg = CONFIG.clinicalTrial;

        /* The donut row belongs between the body copy and the PubMed strip, but
           it is APPENDED and placed with flex `order` in the CSS.
           ⚠️ Inserting it at that position instead is what broke the first
           attempt: the blocks the frame drops are hidden with `:nth-child(n+4)`,
           so slipping a node in above them shifted the strip into 4th place and
           hid it. Appending keeps every original block at its original index,
           which is the only thing those positional selectors can rely on. */
        if (!root.querySelector('.' + P + '__ct-grid')) {
          var grid = el('div', P + '__ct-grid');
          grid.setAttribute('data-' + P + '-built', '');
          for (var c = 0; c < cfg.cards.length; c++) {
            grid.appendChild(trialCard(cfg.cards[c], cfg.ring));
          }
          container.appendChild(grid);
        }

        /* "Read More →" sits OUTSIDE the panel, under it — so it is appended to
           the section wrapper rather than to the container. */
        if (!root.querySelector('.' + P + '__ct-more')) {
          var wrap = container.parentNode;
          if (wrap) {
            var more = el('a', P + '__ct-more');
            more.setAttribute('data-' + P + '-built', '');
            more.setAttribute('href', cfg.readMore.href);
            more.appendChild(document.createTextNode(cfg.readMore.label));
            wrap.appendChild(more);
          }
        }
      }
    },

    {
      id: 'clinicianReviews',
      label: 'Clinician reviews — kill the widget iframe scrollbars',
      run: function () {
        var root = section('frontrow');
        if (!root) return;

        var frame = root.querySelector('.iframe-frontrow-testimonials');
        if (!frame) return;

        /* ⚠️ The widget is FrontrowMD's, on app.thefrontrowhealth.com, so its
           contents are cross-origin and cannot be styled from here. The iframe
           ELEMENT is ours though, and `scrolling` is an attribute on it.

           Why it needs killing: at 1440 exactly, two of the widget's own nodes
           (`.note--provider-column`, `.note--provider-info-extra`) overflow their
           box by 2px. That is enough to raise a horizontal scrollbar, which eats
           16px of height, which pushes the content past the remaining space and
           raises a VERTICAL scrollbar as well — inner document measures 782
           against a 766 client. Below 1200 the widget reflows and neither
           appears, which is why it looks intermittent.

           Nothing is lost by clipping: the overflow is 2px of a provider name.
           `scrolling` is deprecated but universally honoured, and it is the only
           lever that works — an iframe ignores `overflow` on the element. */
        if (frame.getAttribute('scrolling') !== 'no') {
          once(frame, 'noscroll', function (node) {
            node.setAttribute('scrolling', 'no');
            onFailsafe(function () { node.removeAttribute('scrolling'); });
          });
        }
      }
    },

    {
      id: 'ingredients',
      label: 'Ingredients intro — new band replacing "Why mainstream skincare…"',
      run: function () {
        var anchor = section('frontrow');
        if (!anchor || !anchor.parentNode) return;
        if (document.querySelector('.' + P + '__ing')) return;

        var cfg = CONFIG.ingredients;

        var band = el('section', P + '__ing');
        band.setAttribute('data-igacne-section', 'ingredients');
        band.setAttribute('data-' + P + '-built', '');

        var inner = el('div', P + '__ing-inner');

        var title = el('h2', P + '__ing-title');
        for (var t = 0; t < cfg.heading.length; t++) {
          if (t) title.appendChild(el('br'));
          title.appendChild(document.createTextNode(cfg.heading[t]));
        }
        inner.appendChild(title);

        var cards = el('div', P + '__ing-cards');
        for (var c = 0; c < cfg.cards.length; c++) {
          var spec = cfg.cards[c];
          var card = el('div', P + '__ing-card');

          var chip = el('span', P + '__ing-icon');
          chip.appendChild(svg(cfg.icons[spec.icon], P + '__ing-glyph'));
          card.appendChild(chip);

          var h3 = el('h3', P + '__ing-card-title');
          h3.appendChild(document.createTextNode(spec.title));
          card.appendChild(h3);

          card.appendChild(emphasise(el('p', P + '__ing-card-text'), spec.text));
          cards.appendChild(card);
        }
        inner.appendChild(cards);

        var shots = el('div', P + '__ing-shots');
        for (var i = 0; i < cfg.images.length; i++) {
          var fig = el('img', P + '__ing-shot');
          fig.setAttribute('src', cfg.images[i].src);
          fig.setAttribute('alt', cfg.images[i].alt);
          fig.setAttribute('loading', 'lazy');
          shots.appendChild(fig);
        }
        inner.appendChild(shots);

        band.appendChild(inner);
        anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    },

    {
      id: 'trustBadges',
      label: 'Always Free From — new trust-badge band',
      run: function () {
        var anchor = document.querySelector('[data-igacne-section="ingredients"]');
        // built after the ingredients band, so it waits for that to exist
        if (!anchor || !anchor.parentNode) return;
        if (document.querySelector('.' + P + '__tb')) return;

        var cfg = CONFIG.trustBadges;

        var band = el('section', P + '__tb');
        band.setAttribute('data-igacne-section', 'trustBadges');
        band.setAttribute('data-' + P + '-built', '');

        var title = el('h2', P + '__tb-title');
        title.appendChild(document.createTextNode(cfg.heading));
        band.appendChild(title);

        var row = el('div', P + '__tb-row');
        for (var i = 0; i < cfg.badges.length; i++) {
          var spec = cfg.badges[i];
          var item = el('div', P + '__tb-item');
          item.appendChild(svg(cfg.icons[spec.icon], P + '__tb-icon'));

          var label = el('p', P + '__tb-label');
          for (var l = 0; l < spec.lines.length; l++) {
            if (l) label.appendChild(el('br'));
            label.appendChild(document.createTextNode(spec.lines[l]));
          }
          item.appendChild(label);
          row.appendChild(item);
        }
        band.appendChild(row);

        anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    },

    {
      id: 'builtToClear',
      label: 'Built to clear acne fast — reveal, reorder the cards, CTA copy',
      run: function () {
        var root = section('builtToClear');
        if (!root) return;

        var cfg = CONFIG.builtToClear;

        /* Card order, per panel, by name.
           ⚠️ MOVED IN THE DOM, not with flex `order`. `order` was tried first
           and it desynchronises the carousel: these tracks are scrollers with a
           dot per slide, and the theme maps dot index to scroll offset by DOM
           position. Reordering visually while leaving the DOM alone left mobile
           opening at scrollLeft 644 — the middle of the track — with the dots
           pointing at the wrong card. Moving the nodes keeps DOM order, visual
           order and carousel index the same thing.
           Anything not named falls to the end rather than jumping to the front. */
        var panels = root.querySelectorAll('.ni-panel');
        var lists = [cfg.order.day, cfg.order.night, cfg.order.scrub];
        for (var p = 0; p < panels.length && p < lists.length; p++) {
          (function (panel, want) {
            var track = panel.querySelector('.ni-blocks-track');
            if (!track) return;
            once(track, 'cardorder', function (node) {
              var blocks = [];
              var kids = node.querySelectorAll('.ni-block');
              for (var b = 0; b < kids.length; b++) blocks.push(kids[b]);

              // captured before anything moves, so failsafe can put it back
              var original = blocks.slice();
              onFailsafe(function () {
                for (var o = 0; o < original.length; o++) node.appendChild(original[o]);
              });

              var rank = function (card) {
                var name = card.querySelector('.ni-block-title');
                if (!name) return 99;
                for (var i = 0; i < want.length; i++) {
                  if (normalise(want[i]) === normalise(name.textContent)) return i;
                }
                return 99;
              };
              blocks.sort(function (a, b2) { return rank(a) - rank(b2); });
              for (var m = 0; m < blocks.length; m++) node.appendChild(blocks[m]);

              /* Back to the first slide. Scroll anchoring keeps whatever was on
                 screen on screen, so moving the old first card (Arnica) to third
                 left the mobile carousel opening on it — dots in sync, but three
                 slides in. Inside once(), so it never fights a real scroll. */
              if (node.scrollLeft) {
                node.scrollLeft = 0;
                node.dispatchEvent(new Event('scroll'));
              }
            });
          })(panels[p], lists[p]);
        }

        /* Swap each card's art by ingredient name. The <img> is the theme's,
           so rewriting the attribute is enough — and it is captured for the
           failsafe the same way copy is. */
        var allBlocks = root.querySelectorAll('.ni-block');
        for (var a = 0; a < allBlocks.length; a++) {
          var nameNode = allBlocks[a].querySelector('.ni-block-title');
          var pic = allBlocks[a].querySelector('img');
          if (!nameNode || !pic) continue;
          for (var key in cfg.images) {
            if (normalise(key) !== normalise(nameNode.textContent)) continue;
            if (pic.getAttribute('src') !== cfg.images[key]) {
              (function (node, was) {
                once(node, 'art', function () {
                  onFailsafe(function () {
                    if (was === null) node.removeAttribute('src');
                    else node.setAttribute('src', was);
                  });
                });
              })(pic, pic.getAttribute('src'));
              pic.setAttribute('src', cfg.images[key]);
              pic.removeAttribute('srcset');
            }
            break;
          }
        }

        // ticket 2 — per-card copy overrides, matched by name
        for (var c2 = 0; c2 < allBlocks.length; c2++) {
          var cn = allBlocks[c2].querySelector('.ni-block-title');
          var ct = allBlocks[c2].querySelector('.ni-block-text');
          if (!cn || !ct) continue;
          for (var ck in cfg.copy) {
            if (normalise(ck) === normalise(cn.textContent)) { rewrite(ct, cfg.copy[ck]); break; }
          }
        }

        var cta = root.querySelector('.ni-cta-button');
        if (cta) rewrite(cta, cfg.cta);

        /* The guarantee line is "<icon> 60-day money-back guarantee" with the
           icon in its own node, so only that node is touched.
           ⚠️ ROUND 3, TICKET 3 — THE THEME STOPPED SHIPPING THAT NODE.
           `sections/norse-ingredients-section.liquid` rendered
           `<span class="ni-guarantee-check">✓</span>` until commit 1425eba
           (2026-09-02, feature/Whitelister-LP) deleted the line. The old
           `if (mark)` guard turned that into a silent no-op: no error, no dead
           module, just no icon. So the node is BUILT when it is missing.
           It is deliberately not restored to the theme — five other templates
           render this same section and the Whitelister LP wants it gone. */
        var gItem = root.querySelector('.ni-guarantee-item');
        if (gItem && !root.querySelector('.ni-guarantee-check')) {
          once(gItem, 'gmark', function (host) {
            var built = el('span', 'ni-guarantee-check');
            built.setAttribute('aria-hidden', 'true');
            built.setAttribute('data-' + P + '-built', '');
            built.appendChild(document.createTextNode(cfg.guaranteeIcon));
            host.insertBefore(built, host.firstChild);
          });
        }

        var mark = root.querySelector('.ni-guarantee-check');
        if (mark) rewrite(mark, cfg.guaranteeIcon);
      }
    },

    {
      id: 'resultsTable',
      label: 'Why Norse Customers Get Results Faster — comparison table, built',
      run: function () {
        /* Anchored on the section it replaces, which is in CONFIG.hide — hidden
           in CSS, so the node is still in the DOM and still holds its place.
           Inserting after it keeps the band exactly where the control's flat
           image was, which leaves the page order untouched: where this section
           finally sits is CONFIG.order's business, not this module's. */
        var anchor = section('resultsFaster');
        if (!anchor || !anchor.parentNode) return;
        if (document.querySelector('.' + P + '__cmp')) return;

        var cfg = CONFIG.resultsTable;

        var band = el('section', P + '__cmp');
        band.setAttribute('data-igacne-section', 'resultsTable');
        band.setAttribute('data-' + P + '-built', '');

        var inner = el('div', P + '__cmp-inner');

        var title = el('h2', P + '__cmp-title');
        title.appendChild(document.createTextNode(cfg.heading));
        inner.appendChild(title);

        var table = el('div', P + '__cmp-table');

        /* Header row. The label column is an empty spacer at both breakpoints —
           it carries the rule on desktop and does not on mobile, which is the
           one structural difference between the frames and is handled in CSS. */
        var head = el('div', P + '__cmp-row ' + P + '__cmp-row--head');
        head.appendChild(el('div', P + '__cmp-label'));
        head.appendChild(headCell(cfg.columns.good, 'good'));
        head.appendChild(headCell(cfg.columns.bad, 'bad'));
        table.appendChild(head);

        for (var r = 0; r < cfg.rows.length; r++) {
          var spec = cfg.rows[r];
          var row = el('div', P + '__cmp-row');

          var label = el('div', P + '__cmp-label');
          label.appendChild(document.createTextNode(spec.label));
          row.appendChild(label);

          row.appendChild(bodyCell(spec.good, spec.goodShort, 'good', cfg.icons.tick));
          row.appendChild(bodyCell(spec.bad, spec.badShort, 'bad', cfg.icons.cross));
          table.appendChild(row);
        }

        inner.appendChild(table);
        band.appendChild(inner);
        anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    },

    {
      id: 'lessThanOneWeek',
      label: '"..using this less than 1 WEEK" — swap both images, CTA copy',
      run: function () {
        var root = section('lessThanOneWeek');
        if (!root) return;

        var cfg = CONFIG.lessThanOneWeek;

        /* The theme renders BOTH images and shows one per breakpoint, so both
           are swapped. Guarded separately: a markup change to one must not stop
           the other. once() is right here — nothing in the theme rewrites these
           attributes, so we are the only writer, and swapImage() registers its
           own way back for the failsafe. */
        var mobile = root.querySelector('img.review-testimonial__image--mobile');
        if (mobile) {
          once(mobile, 'art', function (node) {
            swapImage(node, cfg.images.mobile, cfg.alt);
          });
        }

        /* ⚠️ The desktop one is NOT a sibling <img>. `.review-testimonial__image
           --desktop` is a <div> WRAPPING the image, while the mobile one is the
           <img> itself — so the same selector shape does not find both. */
        var desktop = root.querySelector('.review-testimonial__image--desktop img');
        if (desktop) {
          once(desktop, 'art', function (node) {
            swapImage(node, cfg.images.desktop, cfg.alt);
          });
        }

        /* rewrite(), not once(): it restores the control string on failsafe,
           and a test whose control arm still carries the variant's CTA copy is
           not measuring what it thinks it is. */
        var cta = root.querySelector('.review-testimonial__cta .cta-button__text');
        if (cta) rewrite(cta, cfg.cta);
      }
    },

    {
      id: 'finalSection',
      label: 'Final section — guarantee + founder merged into why_trust_us',
      run: function () {
        var root = section('whyTrustUs');
        if (!root) return;

        var cfg = CONFIG.finalSection;
        var container = root.querySelector('.why-trust-us__container');
        var title = root.querySelector('.why-trust-us__title');
        if (!container || !title) return;

        /* Eyebrow, above the title. Guarded on the node itself rather than on a
           marker left elsewhere — paint() runs on every mutation, and the rule
           this file settled on is to guard on the thing you injected. */
        if (!container.querySelector('.' + P + '__wt-eyebrow')) {
          var eyebrow = el('p', P + '__wt-eyebrow');
          eyebrow.setAttribute('data-' + P + '-built', '');
          eyebrow.appendChild(document.createTextNode(cfg.eyebrow));
          container.insertBefore(eyebrow, title);
        }

        /* Ticket 6 — break the title after "Everything". The space is left on the
           tail rather than trimmed: CSS drops whitespace at the start of a line,
           and when failsafe removes the <br> the two text nodes rejoin as the
           original run instead of colliding. The <br> carries `-built`, which is
           the whole reversal. */
        (function () {
          var brk = cfg.titleBreakAfter;
          if (!brk) return;
          var first = title.firstChild;
          if (!first || first.nodeType !== 3) return;
          var at = first.nodeValue.indexOf(brk);
          if (at < 0) return;
          once(title, 'titlebreak', function (node) {
            var cut = at + brk.length;
            var tail = document.createTextNode(first.nodeValue.slice(cut));
            first.nodeValue = first.nodeValue.slice(0, cut);
            node.insertBefore(tail, first.nextSibling);
            var br = el('br');
            br.setAttribute('data-' + P + '-built', '');
            node.insertBefore(br, tail);
          });
        })();

        /* The pull quote, at the top of the left column. It is the merged
           section's own <h2>, so it stays an <h2> here. */
        var content = root.querySelector('.why-trust-us__content');
        var text = root.querySelector('.why-trust-us__text');
        if (content && text && !content.querySelector('.' + P + '__wt-quote')) {
          var quote = el('h2', P + '__wt-quote');
          quote.setAttribute('data-' + P + '-built', '');
          quote.appendChild(document.createTextNode(cfg.quote));
          content.insertBefore(quote, text);
        }

        // the frame condenses five paragraphs to three and drops the bold runs
        if (text) once(text, 'body', function (node) { replaceParagraphs(node, cfg.body); });

        /* Both image slots take the same export — the theme shows one per
           breakpoint. See CONFIG for why one file serves both. */
        var shots = root.querySelectorAll('.why-trust-us__image-wrapper img');
        for (var i = 0; i < shots.length; i++) {
          (function (img) {
            once(img, 'art', function (node) { swapImage(node, cfg.image, cfg.alt); });
          })(shots[i]);
        }

        // CTA last, after everything the container already holds
        if (!container.querySelector('.' + P + '__wt-cta')) {
          container.appendChild(ctaButton(cfg.cta, cfg.ctaHref, P + '__wt-cta'));
        }
      }
    },

    {
      id: 'doctorsMothers',
      label: 'Doctors & Mothers — build the frame cast, clamped bio + Read More',
      run: function () {
        var root = section('doctorsMothers');
        if (!root) return;

        var cfg = CONFIG.doctorsMothers;
        var cards = root.querySelectorAll('.norse-ambassador-section__card');
        if (!cards.length) return;

        /* Guarded as ONE pass over the whole section, not per node: this clones
           cards and reorders the track, and paint() re-runs on every mutation —
           including the ones this makes. Per-node guards would still let the
           clone-and-append step fire again and stack duplicates, and the warning
           below would print every frame. */
        once(root, 'people', function () {
          var slideOf = function (card) {
            return card.closest('.norse-ambassador-section__slide') ||
                   card.closest('.norse-ambassador-section__single') ||
                   card.parentNode;
          };

          var nameOf = function (card) {
            var n = card.querySelector('.norse-ambassador-section__name');
            return n ? n.textContent : '';
          };

          // a clone carries the once() flags of whatever it was cloned from
          var clearFlags = function (node) {
            var all = [node].concat([].slice.call(node.querySelectorAll('*')));
            for (var i = 0; i < all.length; i++) {
              var attrs = [].slice.call(all[i].attributes);
              for (var a = 0; a < attrs.length; a++) {
                if (attrs[a].name.indexOf('data-' + P + '-') === 0) {
                  all[i].removeAttribute(attrs[a].name);
                }
              }
            }
            return node;
          };

          var index = {};
          var onPage = [];
          for (var i = 0; i < cards.length; i++) {
            index[normalise(nameOf(cards[i]))] = cards[i];
            onPage.push(cards[i]);
          }

          var track = slideOf(cards[0]).parentNode;
          // taken before anything is rewritten, so it is pure theme markup
          var blank = clearFlags(slideOf(cards[0]).cloneNode(true));

          var fill = function (card, spec) {
            var name = card.querySelector('.norse-ambassador-section__name');
            if (name) name.textContent = spec.name;

            var position = card.querySelector('.norse-ambassador-section__position-text');
            if (position && spec.position) position.textContent = spec.position;

            /* The theme builds these with image_tag, so srcset/sizes still point
               at the metaobject's file and would win over a bare src. */
            var img = card.querySelector('.norse-ambassador-section__avatar-img');
            if (img && spec.image) {
              img.removeAttribute('srcset');
              img.removeAttribute('sizes');
              img.setAttribute('src', spec.image);
              img.setAttribute('alt', spec.name);
            }

            var bio = card.querySelector('.norse-ambassador-section__bio');
            if (!bio) return;
            bio.classList.remove(P + '--open');
            bio.textContent = '';

            /* One <p> holding every paragraph, separated by blank lines rather
               than by sibling <p>s: the collapse is -webkit-line-clamp, which
               only counts the line boxes of the element it is set on, so a
               multi-paragraph bio has to be a single block to clamp evenly. */
            var text = el('p', P + '__amb-text');
            for (var b = 0; b < spec.bio.length; b++) {
              if (b) {
                text.appendChild(el('br'));
                text.appendChild(el('br'));
              }
              text.appendChild(document.createTextNode(spec.bio[b]));
            }
            bio.appendChild(text);

            // a button, not an <a>: it toggles state on the page, it does not navigate
            var toggle = el('button', P + '__amb-more');
            toggle.type = 'button';
            toggle.setAttribute('aria-expanded', 'false');
            toggle.appendChild(document.createTextNode(cfg.readMore));
            toggle.addEventListener('click', function () {
              var open = bio.classList.toggle(P + '--open');
              toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
              toggle.textContent = open ? cfg.readLess : cfg.readMore;
            });
            bio.appendChild(toggle);
          };

          var keep = [];
          var built = [];
          for (var c = 0; c < cfg.people.length; c++) {
            var spec = cfg.people[c];
            var card = index[normalise(spec.name)];
            var slide;
            if (card) {
              slide = slideOf(card);
            } else {
              // not in the metaobject at all — build it from the theme's own markup
              slide = blank.cloneNode(true);
              slide.removeAttribute('id');
              // marks it as ours so failsafe() can take it back out again
              slide.setAttribute('data-' + P + '-built', '');
              card = slide.querySelector('.norse-ambassador-section__card');
              track.appendChild(slide);
              built.push(spec.name);
            }
            fill(card, spec);
            keep.push(slide);
          }

          /* Hide the slide, not the card: the section's own inline script decides
             whether to show the arrows by measuring scrollWidth, so a dropped
             ambassador has to leave the track for that check to come out right. */
          var dropped = [];
          for (var d = 0; d < onPage.length; d++) {
            var slot = slideOf(onPage[d]);
            var wanted = false;
            for (var k = 0; k < keep.length; k++) if (keep[k] === slot) wanted = true;
            if (!wanted) {
              slot.classList.add(P + '--hidden');
              dropped.push(nameOf(onPage[d]).trim());
            }
          }

          /* Reordering moves real theme nodes, which dropping the variant class
             cannot undo — so register the way back before doing it. */
          var wasOrder = [].slice.call(track.children);
          onFailsafe(function () {
            for (var w = 0; w < wasOrder.length; w++) track.appendChild(wasOrder[w]);
          });

          // CONFIG order is the rendered order; appendChild moves, so this sorts
          for (var o = 0; o < keep.length; o++) track.appendChild(keep[o]);
          for (var h = 0; h < onPage.length; h++) {
            var s = slideOf(onPage[h]);
            if (s.classList.contains(P + '--hidden')) track.appendChild(s);
          }

          if (built.length || dropped.length) {
            warn(
              'doctorsMothers: built ' + (built.length ? built.join(', ') : 'nothing') +
              ' (absent from the ambasadors metaobject); hid ' +
              (dropped.length ? dropped.join(', ') : 'nothing')
            );
          }
        });
      }
    },

    {
      id: 'kitRoutine',
      label: 'So Simple It Fits Anyone’s Routines — new band after Doctors & Mothers',
      run: function () {
        var anchor = section('doctorsMothers');
        if (!anchor || !anchor.parentNode) return;

        /* Guard on the band's own presence rather than a marker on the anchor,
           the same way the Trustpilot band does: if anything re-renders this part
           of the page it is simply rebuilt on the next paint instead of staying
           gone. */
        if (document.querySelector('.' + P + '__kit')) return;

        var cfg = CONFIG.kitRoutine;
        loadDmSans();

        var band = el('section', P + '__kit');
        // addressable by the reorder once CONFIG.order is filled in
        band.setAttribute('data-igacne-section', 'kitRoutine');
        // ours, not the theme's — failsafe() takes it back out
        band.setAttribute('data-' + P + '-built', '');

        var inner = el('div', P + '__kit-inner');

        var head = el('div', P + '__kit-head');
        var title = el('h2', P + '__kit-title');
        title.appendChild(document.createTextNode(cfg.heading));
        head.appendChild(title);
        var pill = el('p', P + '__kit-pill');
        pill.appendChild(document.createTextNode(cfg.pill));
        head.appendChild(pill);
        inner.appendChild(head);

        var grid = el('div', P + '__kit-grid');
        for (var i = 0; i < cfg.products.length; i++) {
          grid.appendChild(kitItem(cfg.products[i]));
        }
        inner.appendChild(grid);

        band.appendChild(inner);
        anchor.parentNode.insertBefore(band, anchor.nextSibling);
      }
    },

    {
      id: 'reviewsJump',
      label: 'Point every reviews click at Severe Acne Fixed in Weeks',
      run: function () {
        if (!reviewsHref()) return;

        /* Buy-box stars (and any other Loox / Trustpilot-profile anchors).
           Re-asserted every paint — product-info can rewrite href="#looxReviews". */
        var anchors = document.querySelectorAll(
          'a[href="#looxReviews"], a[href*="trustpilot.com/review"], a.' + P + '__tp-link'
        );
        for (var i = 0; i < anchors.length; i++) pointAnchorAtReviews(anchors[i]);

        var hero = section('hero');
        if (hero) bindReviewsJump(hero.querySelector('.hero-fullwidth-split__reviews'));

        var buy = section('buyBox');
        if (buy) {
          var ratings = buy.querySelectorAll('a.rating-wrapper');
          for (var r = 0; r < ratings.length; r++) pointAnchorAtReviews(ratings[r]);
          bindReviewsJump(buy.querySelector('.' + P + '__bb-review'));
        }
      }
    }
  ];

  function runModules() {
    for (var i = 0; i < MODULES.length; i++) {
      var mod = MODULES[i];
      if (modulesRun[mod.id] === 'dead') continue;
      try {
        mod.run();
      } catch (error) {
        modulesRun[mod.id] = 'dead';
        warn('module "' + mod.id + '" (' + mod.label + ') failed and was disabled: ' + error);
      }
    }
  }

  /* ── Paint loop ───────────────────────────────────────────────────── */

  var painting = false;
  /* Set by failsafe(). The MutationObserver stays connected for the session, and
     removing the built bands is itself a mutation — so without this the next
     paint() rebuilds every one of them, now with html.igacne-v1 gone, and the
     page ends up carrying the injected sections completely unstyled. Caught on
     the live page by qa/live-probe.js: the kit band came back 8033px tall. */
  var disabled = false;

  function paint() {
    if (painting || disabled) return;
    painting = true;
    try {
      applyOrder();
      applyHide();
      runModules();
      if (!mounted) {
        mounted = true;
        docEl().classList.add(CONFIG.activeClass);
      }
    } finally {
      painting = false;
    }
  }

  /* Anything a module does that dropping html.igacne-v1 will NOT undo has to
     register its own reversal here. Styling and hiding are covered by the class;
     moving or creating nodes is not. */
  var undos = [];

  function onFailsafe(fn) {
    undos.push(fn);
  }

  function failsafe(err) {
    // first, so nothing this function does can trigger a repaint that undoes it
    disabled = true;
    lastError = err || 'failsafe: control restored';
    try {
      for (var u = 0; u < undos.length; u++) {
        try { undos[u](); } catch (e) {}
      }
      undos = [];

      /* Nodes a module BUILT are not the theme's and would survive as unstyled
         duplicates, so they are marked and removed. */
      var built = document.querySelectorAll('[data-' + P + '-built]');
      for (var i = 0; i < built.length; i++) {
        if (built[i].parentNode) built[i].parentNode.removeChild(built[i]);
      }

      docEl().classList.remove(CONFIG.variantClass);
      docEl().classList.remove(CONFIG.activeClass);
    } catch (e) {}
    warn(err || 'failsafe: control restored');
  }

  /* Exposed so "does this actually degrade to control?" can be answered by
     running it, rather than by reading the code and hoping. Nothing in the page
     calls it; QA does: `window.__igacne.failsafe()`. */
  window.__igacne = {
    failsafe: failsafe,

    /* `window.__igacne.state()` in the console. There is exactly one symptom
       when this test goes wrong — the page looks like control — and it covers
       several very different causes, so this reports which one:
         · flag false                   -> Intelligems never added igacne-v1.
                                           EXPECTED for control visitors; for a
                                           variant visitor it means the test's
                                           Custom JS one-liner is missing.
         · onPage false                 -> the path guard, wrong URL
         · flag true, started false     -> the asset did not load; check that
                                           theme.liquid still includes it for
                                           this template
         · disabled true                -> a failsafe fired, see `error`
         · started true, modules dead   -> that module threw, the rest are fine
       Cheap enough to leave in; QA and a human both want the same answer. */
    state: function () {
      var dead = [];
      for (var id in modulesRun) {
        if (modulesRun[id] === 'dead') dead.push(id);
      }
      return {
        flag: isOn(),
        onPage: onTargetPage(),
        started: started,
        mounted: mounted,
        disabled: disabled,
        error: lastError ? String(lastError) : null,
        deadModules: dead,
        htmlClass: docEl() ? docEl().className : '(no documentElement)'
      };
    }
  };

  /* ── The gate ─────────────────────────────────────────────────────────
   * This file ships as a THEME ASSET and loads for every visitor to the page,
   * control included. It must therefore do nothing at all until Intelligems
   * says so, and "says so" is one line in the test's Custom JS:
   *
   *     document.documentElement.classList.add('igacne-v1')
   *
   * ⚠️ THE CLASS IS NO LONGER OURS TO ADD. Adding it here would put every
   * visitor in the variant and there would be no experiment left to measure.
   * The CSS is scoped to the same class, so it is inert by the same switch.
   *
   * Intelligems may set it before this file executes or after, so both are
   * handled: check once, then watch documentElement's class attribute.
   * -------------------------------------------------------------------- */
  function isOn() {
    var root = docEl();
    return !!root && root.classList.contains(CONFIG.variantClass);
  }

  var gate = null;

  function armGate() {
    if (!onTargetPage()) return;

    /* ⚠️ WAIT, DO NOT FAILSAFE, if there is no <html> yet. Whether
       documentElement exists depends entirely on how early this runs, which is
       not ours to control. Treating "too early" as a failure is what once
       turned a timing difference into a dead test. */
    if (!docEl()) {
      window.setTimeout(armGate, 0);
      return;
    }

    if (isOn()) {
      start();
      return;
    }

    if (window.MutationObserver) {
      gate = new MutationObserver(function () {
        if (disabled) {
          if (gate) { gate.disconnect(); gate = null; }
          return;
        }
        if (!isOn()) return;
        if (gate) { gate.disconnect(); gate = null; }
        start();
      });
      gate.observe(docEl(), { attributes: true, attributeFilter: ['class'] });
    }

    /* Belt and braces for the no-MutationObserver case and for anything that
       sets the class without a mutation this observer sees. Cheap, and the
       alternative is a variant that silently never turns on. */
    document.addEventListener('DOMContentLoaded', armGate);
    window.addEventListener('pageshow', armGate);
  }

  function start() {
    if (started || disabled) return;
    started = true;

    try {
      paint();
    } catch (err) {
      failsafe(err);
      return;
    }

    /* The observer stays connected for the session. Disconnecting after a few
       seconds meant any late re-render — apps, consent scripts, Intelligems —
       wiped the variant with nothing left to restore it. paint() is cheap and
       every module is guarded, so re-running it is safe; it is only throttled to
       one call per frame. */
    if (window.MutationObserver) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          paint();
        });
      }).observe(docEl(), { childList: true, subtree: true });
    }

    document.addEventListener('DOMContentLoaded', paint);
    document.addEventListener('shopify:section:load', paint);
    window.addEventListener('pageshow', paint);
  }

  try {
    armGate();
  } catch (err) {
    failsafe(err);
  }
})();
